import { g as ke } from "./TrackerDataModel-D7fU-Wum.js";
import { z as rn, A as sn, B as an, C as on, E as ln, F as cn, G as un, H as dn, h as Ke, s as re, c as ge, b as ce, I as Fe, J as fn, K as mn, L as Nt, N as pn, d as be, P as Xe, Q as Ne, j as ot, V as De, M as yn, W as it, X as gn, Y as hn, R as kn, p as bn, a as Je, u as vn, Z as wn, _ as Sn, $ as Tn, q as Dt, a0 as Me, a1 as Et, a2 as In, a3 as Qe, D as lt, a4 as Cn, e as ie, a5 as Oe, a6 as xn, a7 as Rt, a8 as An, a9 as Nn, v as Dn, aa as En, ab as Rn, ac as Mn, ad as _n, ae as Ln } from "./trackerSavedViews-B1fUFnV-.js";
import On, { useMemo as F, useEffect as ve, useContext as we, createContext as Kn, useRef as X, useCallback as z, useSyncExternalStore as Mt, useState as U, Suspense as _t, lazy as Lt } from "react";
import { jsxs as D, jsx as g, Fragment as Fn } from "react/jsx-runtime";
import { M as ne } from "./MaterialSymbol-hT2awJjQ.js";
import { P as Bn, s as Pn, c as ct } from "./index-CgGCtE61.js";
import { RevoGrid as $n } from "@revolist/react-datagrid";
import { createRoot as Vn } from "react-dom/client";
import { u as jn, a as Un, o as zn, f as Yn, s as Wn, b as Gn, c as Hn, d as qn, e as Xn, F as Jn } from "./floating-ui.react-87bo4V3_.js";
function Qn(e) {
  return e === !0 || e === 1;
}
const Be = "plan-status-drift";
function Ot(e) {
  if (e.primaryType !== "plan") return [];
  if (e.status !== "draft" && e.status !== "ready-for-development") return [];
  const t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = Array.isArray(e.linkedCommits) ? e.linkedCommits : [];
  for (const s of r)
    s.sessionId && (t.add(s.sessionId), n.add(s.sha));
  return t.size === 0 ? [] : [{
    kind: Be,
    reason: "linked-session-committed",
    status: e.status,
    committedSessionIds: [...t],
    commitShas: [...n]
  }];
}
const ut = "depends-on", dt = "blocks";
function Zn(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  for (const o of t) {
    const i = n.getId(o), u = n.getType(o), d = n.getStatus(o);
    r.set(i, {
      item: o,
      id: i,
      type: u,
      status: d,
      terminal: sn(e, u, d)
    });
  }
  const s = /* @__PURE__ */ new Map(), a = (o, i) => {
    let u = s.get(o);
    u || (u = /* @__PURE__ */ new Set(), s.set(o, u)), u.add(i);
  };
  for (const o of r.values()) {
    const i = e.getTypeModel(o.type)?.fields ?? [];
    for (const u of i) {
      if (!an(u) || u.relationshipTypeKey !== ut && u.relationshipTypeKey !== dt)
        continue;
      const d = on(
        n.getFieldValue(o.item, u.name)
      );
      for (const l of d) {
        const m = l.relationshipTypeKey ?? u.relationshipTypeKey;
        m === ut ? a(o.id, l.itemId) : m === dt && a(l.itemId, o.id);
      }
    }
  }
  return { nodesById: r, blockerIdsByDependentId: s };
}
class er {
  constructor(t) {
    this.parent = /* @__PURE__ */ new Map();
    for (const n of t) this.parent.set(n, n);
  }
  /**
   * Two iterative passes rather than recursion. Union links the larger root
   * under the smaller one, with no rank or size heuristic, so a graph whose
   * merges arrive in descending-root order builds a parent chain as long as the
   * component -- and the first find on it would recurse that whole depth before
   * path compression ever runs.
   */
  find(t) {
    let n = t;
    for (; ; ) {
      const s = this.parent.get(n);
      if (!s || s === n) break;
      n = s;
    }
    let r = t;
    for (; r !== n; ) {
      const s = this.parent.get(r);
      this.parent.set(r, n), r = s;
    }
    return n;
  }
  union(t, n) {
    const r = this.find(t), s = this.find(n);
    if (r === s) return;
    const [a, o] = r < s ? [r, s] : [s, r];
    this.parent.set(o, a);
  }
}
function tr(e) {
  const t = [...e.nodesById.values()].filter((f) => !f.terminal).map((f) => f.id).sort(), n = new Set(t), r = new Map(t.map((f) => [f, []])), s = /* @__PURE__ */ new Set(), a = new er(t);
  for (const f of t) {
    const h = e.blockerIdsByDependentId.get(f);
    if (h)
      for (const S of [...h].sort())
        n.has(S) && (r.get(f)?.push(S), S === f && s.add(f), a.union(f, S));
  }
  let o = 0;
  const i = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), d = [], l = /* @__PURE__ */ new Set(), m = [], c = [], p = (f) => {
    const h = o++;
    i.set(f, h), u.set(f, h), d.push(f), l.add(f), c.push({ id: f, edgeIndex: 0 });
  }, y = (f) => {
    for (p(f); c.length > 0; ) {
      const h = c[c.length - 1], S = r.get(h.id) ?? [];
      if (h.edgeIndex < S.length) {
        const k = S[h.edgeIndex++];
        i.has(k) ? l.has(k) && u.set(
          h.id,
          Math.min(u.get(h.id), i.get(k))
        ) : p(k);
        continue;
      }
      if (c.pop(), u.get(h.id) === i.get(h.id)) {
        const k = [];
        let b;
        do
          b = d.pop(), l.delete(b), k.push(b);
        while (b !== h.id);
        m.push(k.sort());
      }
      const A = c[c.length - 1];
      A && u.set(
        A.id,
        Math.min(u.get(A.id), u.get(h.id))
      );
    }
  };
  for (const f of t)
    i.has(f) || y(f);
  const I = /* @__PURE__ */ new Map();
  for (const f of t) {
    const h = a.find(f), S = I.get(h);
    (!S || f < S) && I.set(h, f);
  }
  const v = /* @__PURE__ */ new Map();
  for (const f of t)
    v.set(f, I.get(a.find(f)) ?? f);
  return {
    cycles: m.filter(
      (f) => f.length > 1 || s.has(f[0])
    ),
    trackIdByItemId: v
  };
}
function nr(e, t) {
  return e ? "closed" : t > 0 ? "blocked" : "ready";
}
function rr(e, t, n) {
  const r = Zn(e, t, n), s = tr(r), a = new Set(s.cycles.flat()), o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  for (const l of r.nodesById.values()) {
    const m = [], c = [];
    for (const p of r.blockerIdsByDependentId.get(l.id) ?? []) {
      const y = r.nodesById.get(p);
      y ? y.terminal || m.push(p) : c.push(p);
    }
    o.set(l.id, m.sort()), i.set(l.id, c.sort());
  }
  const u = /* @__PURE__ */ new Map();
  for (const l of r.nodesById.values()) {
    if (l.terminal) continue;
    const m = o.get(l.id) ?? [];
    if (m.length !== 1) continue;
    const c = m[0];
    c !== l.id && u.set(c, (u.get(c) ?? 0) + 1);
  }
  const d = /* @__PURE__ */ new Map();
  for (const l of r.nodesById.values()) {
    const c = (o.get(l.id) ?? []).map((p) => {
      const y = r.nodesById.get(p), I = n.getReference(y.item), v = n.getTitle(y.item);
      return {
        itemId: y.id,
        ref: I.ref,
        refStatus: I.refStatus,
        ...v ? { title: v } : {},
        type: y.type,
        status: y.status,
        statusCategory: rn(e, y.type, y.status)
      };
    });
    d.set(l.id, {
      state: nr(l.terminal, c.length),
      blockedBy: c,
      unresolvedBlockerIds: i.get(l.id) ?? [],
      unblocks: u.get(l.id) ?? 0,
      inCycle: a.has(l.id),
      trackId: s.trackIdByItemId.get(l.id) ?? l.id
    });
  }
  return d;
}
function sr(e, t = (n) => {
  const r = cn(e, n.primaryType);
  return String(n.fields[r] ?? "");
}) {
  return {
    getId: (n) => n.id,
    getType: (n) => n.primaryType,
    getStatus: t,
    getTitle: (n) => {
      const r = e.getTypeModel(n.primaryType)?.roles?.title ?? "title", s = n.fields[r];
      return typeof s == "string" && s ? s : void 0;
    },
    getFieldValue: (n, r) => n.fields[r],
    getReference: (n) => {
      const r = ln(n);
      return r === void 0 ? { ref: n.id, refStatus: "unassigned" } : {
        ref: r,
        refStatus: n.localKey && r === n.localKey ? "local" : "assigned"
      };
    }
  };
}
function ar(e, t, n) {
  return rr(e, t, sr(e, n));
}
const Q = 3600 * 1e3, Pe = 24 * Q, $e = 24, or = 2, ir = 72, lr = 600 * 1e3, cr = Q, ur = 3 * Pe, dr = 480 * 1e3, ye = {
  email: null,
  displayName: "Automation",
  gitName: null,
  gitEmail: null
};
function Ve(e) {
  return Math.min(ir, Math.max(or, e));
}
function fr(e = {}) {
  const t = e.nowMs ?? Date.now();
  if (Number.isFinite(e.windowHours)) {
    const n = Ve(Number(e.windowHours));
    return {
      startAt: t - n * Q,
      endAt: t,
      windowHours: n,
      source: "preset"
    };
  }
  if (Number.isFinite(e.lastSeenAt)) {
    const n = Math.max(0, t - Number(e.lastSeenAt)) / Q, r = Ve(n);
    return {
      startAt: t - r * Q,
      endAt: t,
      windowHours: r,
      source: "since-left"
    };
  }
  return {
    startAt: t - $e * Q,
    endAt: t,
    windowHours: $e,
    source: "default"
  };
}
function Ce(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return null;
  const t = e, n = typeof t.displayName == "string" ? t.displayName.trim() : "", r = typeof t.email == "string" && t.email.trim() ? t.email.trim() : null, s = typeof t.gitName == "string" && t.gitName.trim() ? t.gitName.trim() : null, a = typeof t.gitEmail == "string" && t.gitEmail.trim() ? t.gitEmail.trim() : null;
  return !n && !r && !s && !a ? null : {
    email: r,
    displayName: n || r || s || "Unknown",
    gitName: s,
    gitEmail: a
  };
}
function se(e) {
  if (!e) return "automation";
  if (e.email) return `email:${e.email.trim().toLowerCase()}`;
  if (e.gitEmail)
    return `git-email:${e.gitEmail.trim().toLowerCase()}`;
  if (e.gitName)
    return `git-name:${e.gitName.trim().toLowerCase()}`;
  const t = e.displayName.trim().toLowerCase();
  return t ? `name:${t}` : "automation";
}
function mr(e, t) {
  return se(e) === se(t);
}
function xe(e) {
  if (typeof e == "number" && Number.isFinite(e)) return e;
  if (typeof e != "string" || !e.trim()) return null;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : null;
}
function Ie(e) {
  return typeof e == "string" ? e : e == null ? void 0 : String(e);
}
function pr(e) {
  const t = e.fields.title ?? e.fields.name;
  return typeof t == "string" && t.trim() ? t.trim() : e.issueKey ?? e.id;
}
function yr(e) {
  const t = e.fields.status ?? e.fields.state;
  return typeof t == "string" && t.trim() ? t.trim() : "active";
}
function Kt(e) {
  const t = Array.isArray(e.system.comments) ? e.system.comments : [], n = /* @__PURE__ */ new Set(), r = [];
  for (const a of t) {
    if (!a || typeof a != "object" || a.deleted)
      continue;
    const o = xe(a.createdAt);
    if (o === null) continue;
    const i = Ce(a.authorIdentity) ?? ye, u = se(i);
    n.add(`${u}:${o}`), r.push({
      id: typeof a.id == "string" && a.id ? a.id : `comment:${e.id}:${o}`,
      itemId: e.id,
      actor: i,
      actorKey: u,
      action: "commented",
      timestamp: o,
      source: "comment",
      body: typeof a.body == "string" ? a.body : void 0
    });
  }
  const s = Array.isArray(e.system.activity) ? e.system.activity : [];
  for (const [a, o] of s.entries()) {
    if (!o || typeof o != "object" || Array.isArray(o)) continue;
    const i = o, u = xe(i.timestamp);
    if (u === null) continue;
    const d = Ce(i.authorIdentity) ?? ye, l = se(d), m = typeof i.action == "string" ? i.action : "updated";
    m === "commented" && n.has(`${l}:${u}`) || r.push({
      id: typeof i.id == "string" && i.id ? i.id : `activity:${e.id}:${u}:${a}`,
      itemId: e.id,
      actor: d,
      actorKey: l,
      action: m,
      timestamp: u,
      source: "activity",
      field: Ie(i.field),
      oldValue: Ie(i.oldValue),
      newValue: Ie(i.newValue),
      note: Ie(i.note)
    });
  }
  if (r.length === 0) {
    const a = xe(e.system.updatedAt);
    if (a !== null) {
      const o = Ce(
        e.system.lastModifiedBy ?? e.system.authorIdentity
      ) ?? ye;
      r.push({
        id: `fallback:${e.id}:${a}`,
        itemId: e.id,
        actor: o,
        actorKey: se(o),
        action: "updated",
        timestamp: a,
        source: "fallback"
      });
    }
  }
  return r.sort(
    (a, o) => a.timestamp - o.timestamp || a.id.localeCompare(o.id)
  );
}
function gr(e, t) {
  if (e.length === 0) return [];
  const n = e.filter((o) => o.action === "status_changed");
  if (n.length === 0)
    return [
      {
        state: t,
        startAt: e[0].timestamp,
        endAt: e[e.length - 1].timestamp
      }
    ];
  let r = n[0].oldValue || t, s = e[0].timestamp;
  const a = [];
  for (const o of n)
    a.push({ state: r, startAt: s, endAt: o.timestamp }), r = o.newValue || r, s = o.timestamp;
  return a.push({
    state: r,
    startAt: s,
    endAt: e[e.length - 1].timestamp
  }), a;
}
function ft(e) {
  const t = e.events[e.events.length - 1];
  return `${t.action}:${t.field ?? ""}`;
}
function hr(e, t) {
  return t === 1 || e.endsWith("s") ? e : e.endsWith("y") ? `${e.slice(0, -1)}ies` : `${e}s`;
}
function kr(e, t) {
  const n = e.events[e.events.length - 1], r = `${t} ${hr(e.primaryType, t)}`;
  return n.action === "status_changed" ? `Moved ${r}` : n.action === "commented" ? `Commented on ${r}` : n.action === "created" ? `Created ${r}` : n.field ? `Set ${n.field} on ${r}` : `Updated ${r}`;
}
function br(e, t, n) {
  const r = [...e].sort(
    (o, i) => o.startAt - i.startAt || o.id.localeCompare(i.id)
  ), s = [];
  let a = 0;
  for (; a < r.length; ) {
    const o = r[a], i = [o];
    let u = a + 1;
    for (; u < r.length; ) {
      const l = r[u], m = i[i.length - 1];
      if (l.primaryType !== o.primaryType || ft(l) !== ft(o) || l.startAt - m.endAt >= t)
        break;
      i.push(l), u += 1;
    }
    const d = [...new Set(i.flatMap((l) => l.itemIds))];
    if (d.length >= n) {
      const l = i.flatMap((c) => c.events).sort((c, p) => c.timestamp - p.timestamp), m = i.flatMap((c) => c.items);
      s.push({
        id: `run:${o.actorKey}:${o.primaryType}:${l[0].timestamp}`,
        kind: "run",
        actorKey: o.actorKey,
        itemIds: d,
        items: m,
        primaryType: o.primaryType,
        label: kr(o, d.length),
        state: i[i.length - 1].state,
        startAt: Math.min(...i.map((c) => c.startAt)),
        endAt: Math.max(...i.map((c) => c.endAt)),
        lastActivityAt: Math.max(...i.map((c) => c.lastActivityAt)),
        row: 0,
        events: l,
        segments: [],
        agentDriven: i.some((c) => c.agentDriven),
        hasCommit: i.some((c) => c.hasCommit),
        truncatedStart: i.some((c) => c.truncatedStart)
      });
    } else
      s.push(...i);
    a = u;
  }
  return s.sort(
    (o, i) => o.startAt - i.startAt || o.id.localeCompare(i.id)
  );
}
function vr(e) {
  const t = [];
  for (const n of e) {
    const r = Math.max(n.endAt, n.startAt + dr);
    let s = t.findIndex((a) => a <= n.startAt);
    s < 0 && (s = t.length), n.row = s, t[s] = r;
  }
  return Math.max(1, t.length);
}
function wr(e, t) {
  const n = e.map((i) => i.state.toLowerCase()), r = n.filter(
    (i) => i === "done" || i === "completed" || i === "closed"
  ).length, s = n.filter(
    (i) => i === "in-review" || i === "review"
  ).length, a = e.filter((i) => i.kind === "run").length, o = [];
  return r && o.push(`${r} completed`), s && o.push(`${s} in review`), a && o.push(`${a} sweep${a === 1 ? "" : "s"}`), t && o.push(`${t} stalled`), o.length === 0 && o.push(`${new Set(e.flatMap((i) => i.itemIds)).size} active`), o.join(" · ");
}
function Sr(e, t) {
  let n = Number.POSITIVE_INFINITY;
  for (const r of e)
    for (const s of t)
      n = Math.min(n, Math.abs(r.timestamp - s.timestamp));
  return n;
}
function mt(e) {
  return e.action === "commented" ? "commented" : e.action === "status_changed" ? "reviewed" : e.action === "created" ? "handed-off" : "updated";
}
function pa(e, t = {}) {
  const n = fr(t), r = t.currentIdentity ? se(t.currentIdentity) : null, s = t.getTitle ?? pr, a = t.getStatus ?? yr, o = /* @__PURE__ */ new Map(), i = new Map(e.map((f) => [f.id, f])), u = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map();
  for (const f of e) {
    const h = Kt(f);
    o.set(f.id, h);
    const S = h.filter(
      (k) => k.timestamp >= n.startAt && k.timestamp <= n.endAt
    ), A = /* @__PURE__ */ new Map();
    for (const k of S) {
      d.set(k.actorKey, k.actor);
      const b = A.get(k.actorKey) ?? [];
      b.push(k), A.set(k.actorKey, b);
    }
    for (const [k, b] of A) {
      const C = a(f), E = b[0].timestamp, L = b[b.length - 1].timestamp, V = {
        id: `thread:${k}:${f.id}`,
        kind: "thread",
        actorKey: k,
        itemIds: [f.id],
        items: [f],
        primaryType: f.primaryType,
        label: s(f),
        state: C,
        startAt: E,
        endAt: L,
        lastActivityAt: L,
        row: 0,
        events: b,
        segments: gr(b, C),
        agentDriven: f.system.createdByAgent === !0,
        hasCommit: !!(f.system.linkedCommitSha || f.system.linkedCommits?.length),
        truncatedStart: (f.system.activity?.length ?? 0) >= 100 && h[0]?.timestamp === E
      }, P = u.get(k) ?? [];
      P.push(V), u.set(k, P);
    }
  }
  const l = [];
  for (const [f, h] of o) {
    const S = i.get(f), A = h.filter(
      (C) => C.timestamp >= n.startAt && C.timestamp <= n.endAt && C.actorKey !== "automation"
    ), k = /* @__PURE__ */ new Map();
    for (const C of A) {
      const E = k.get(C.actorKey) ?? [];
      E.push(C), k.set(C.actorKey, E);
    }
    const b = [...k.entries()];
    for (let C = 0; C < b.length; C += 1)
      for (let E = C + 1; E < b.length; E += 1) {
        const [L, V] = b[C], [P, N] = b[E], Y = V[0].timestamp, G = N[0].timestamp, [Z, J, de, T] = Y <= G ? [L, V, P, N] : [P, N, L, V], _ = Sr(V, N) <= (t.overlapMs ?? cr), j = T.some(
          (M) => M.action === "commented" || M.action === "status_changed"
        );
        l.push({
          itemId: f,
          issueKey: S.issueKey,
          title: s(S),
          type: _ ? "overlap" : j ? "review" : "hand-off",
          fromActorKey: Z,
          toActorKey: de,
          fromAt: J[J.length - 1].timestamp,
          toAt: T[0].timestamp
        });
      }
  }
  const m = [], c = [];
  if (r)
    for (const [f, h] of o) {
      const S = h.filter(
        (N) => N.actorKey !== "automation" && N.timestamp <= n.endAt
      ), A = S.filter(
        (N) => N.actorKey === r
      ), k = A[A.length - 1];
      if (!k) continue;
      const b = S.filter(
        (N) => N.timestamp >= n.startAt
      ), C = b[b.length - 1];
      if (!C) continue;
      const E = i.get(f), L = b.filter(
        (N) => N.actorKey !== r
      );
      if (L.length === 0) continue;
      const V = L.filter(
        (N) => N.timestamp > k.timestamp && (N.action === "commented" || N.action === "status_changed")
      ), P = V[V.length - 1];
      if (P)
        m.push({
          itemId: f,
          issueKey: E.issueKey,
          title: s(E),
          actor: P.actor,
          at: P.timestamp,
          reason: mt(P)
        });
      else if (C.actorKey === r) {
        const N = L[L.length - 1];
        c.push({
          itemId: f,
          issueKey: E.issueKey,
          title: s(E),
          actor: N.actor,
          at: C.timestamp,
          reason: mt(C)
        });
      }
    }
  const p = /* @__PURE__ */ new Map(), y = n.endAt - (t.stalledAfterMs ?? ur);
  for (const f of e) {
    const h = a(f).toLowerCase();
    if (h !== "in-progress" && h !== "in-review") continue;
    const S = o.get(f.id) ?? [], A = S[S.length - 1], k = A?.timestamp ?? xe(f.system.updatedAt);
    if (k == null || k > y)
      continue;
    const b = A?.actor ?? Ce(f.system.lastModifiedBy) ?? ye, C = se(b);
    d.set(C, b);
    const E = p.get(C) ?? [];
    E.push({
      itemId: f.id,
      issueKey: f.issueKey,
      title: s(f),
      state: h,
      lastActivityAt: k
    }), p.set(C, E);
  }
  const v = [.../* @__PURE__ */ new Set([...u.keys(), ...p.keys()])].map((f) => {
    const h = br(
      u.get(f) ?? [],
      t.runGapMs ?? lr,
      t.runMinItems ?? 3
    ), S = vr(h), A = (p.get(f) ?? []).sort(
      (b, C) => C.lastActivityAt - b.lastActivityAt
    );
    return {
      actor: d.get(f) ?? ye,
      actorKey: f,
      isCurrentUser: f === r,
      isAutomation: f === "automation",
      summary: wr(h, A.length),
      lastActivityAt: Math.max(
        0,
        ...h.map((b) => b.lastActivityAt),
        ...A.map((b) => b.lastActivityAt)
      ),
      marks: h,
      subRowCount: S,
      stalled: A,
      presence: t.presenceByActorKey?.[f],
      enrichment: t.enrichmentByActorKey?.[f]
    };
  }).sort((f, h) => f.isCurrentUser !== h.isCurrentUser ? f.isCurrentUser ? -1 : 1 : f.isAutomation !== h.isAutomation ? f.isAutomation ? 1 : -1 : h.lastActivityAt - f.lastActivityAt || f.actor.displayName.localeCompare(h.actor.displayName));
  return {
    windowStart: n.startAt,
    windowEnd: n.endAt,
    windowHours: n.windowHours,
    windowSource: n.source,
    lanes: v,
    ties: l.sort((f, h) => h.toAt - f.toAt),
    waitingOnYou: m.sort((f, h) => h.at - f.at),
    youHandedOff: c.sort((f, h) => h.at - f.at)
  };
}
function Tr(e, t) {
  const n = Math.max(0, t - e);
  return n < 6e4 ? "now" : n < Q ? `${Math.floor(n / 6e4)}m ago` : n < Pe ? `${Math.floor(n / Q)}h ago` : `${Math.floor(n / Pe)}d ago`;
}
function Ir(e, t, n = Date.now(), r = $e) {
  if (!t) return null;
  const s = n - Ve(r) * Q, a = Kt(e).filter((d) => d.timestamp >= s && d.timestamp <= n).filter(
    (d) => d.actorKey !== "automation" && !mr(d.actor, t)
  ), o = a[a.length - 1];
  if (!o) return null;
  const i = o.action === "status_changed" ? "changed status" : o.action === "commented" ? "commented" : o.action === "created" ? "created this item" : "updated this item", u = Tr(o.timestamp, n);
  return {
    actor: o.actor,
    action: o.action,
    at: o.timestamp,
    relativeLabel: u,
    summary: `${o.actor.displayName} ${i} ${u}`
  };
}
function Cr(e) {
  const t = Ot({
    primaryType: e.primaryType,
    status: e.fields.status,
    linkedCommits: e.system.linkedCommits
  });
  return t.length > 0 && (e.system.derivedSignals = [
    ...e.system.derivedSignals ?? [],
    ...t
  ]), e;
}
function xr(e) {
  if (Array.isArray(e))
    return e.map((t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        return t;
      const n = t;
      if (n.updatedAt != null) return n;
      const { updatedAt: r, ...s } = n;
      return s;
    });
}
const Ft = /* @__PURE__ */ new Set([
  "authorIdentity",
  "lastModifiedBy",
  "createdByAgent",
  "linkedSessions",
  "linkedCommitSha",
  "linkedCommits",
  "linkedPullRequests",
  "linkedIssues",
  "documentId",
  "activity",
  "comments",
  "origin",
  "triagedAt",
  "triagedBy",
  "derivedSignals",
  // also pulled from row-level columns, not from data JSONB
  "assigneeId",
  "reporterId"
]), pt = /* @__PURE__ */ new Set([
  // top-level record props
  "id",
  "type",
  "typeTags",
  "issueNumber",
  "issueKey",
  "localKey",
  "source",
  "sourceRef",
  "archived",
  "archivedAt",
  "syncStatus",
  "content",
  "module",
  "lineNumber",
  "workspace",
  "lastIndexed",
  "created",
  "updated",
  // system keys
  ...Ft,
  // deprecated compat keys
  "assigneeId",
  "reporterId",
  // old catch-all that's being replaced
  "customFields"
]);
function Ar(e) {
  if (!e) return !1;
  const t = e.trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(t) || /^\d{4}-\d{2}-\d{2}T00:00:00(?:\.000)?Z$/.test(t);
}
function Nr(e, t) {
  const n = e.updated ?? e.created;
  return e.source === "frontmatter" && t && Ar(n) ? t : e.updated ?? e.created ?? t;
}
function Dr(e) {
  const t = {};
  for (const [o, i] of Object.entries(e))
    i !== void 0 && (pt.has(o) || (t[o] = i));
  if (e.customFields)
    for (const [o, i] of Object.entries(e.customFields))
      i !== void 0 && !pt.has(o) && (t[o] = i);
  const n = e.lastIndexed instanceof Date ? e.lastIndexed.toISOString() : typeof e.lastIndexed == "string" ? e.lastIndexed : void 0, r = (/* @__PURE__ */ new Date(0)).toISOString(), s = Nr(e, n) ?? r, a = {
    id: e.id,
    primaryType: e.type,
    typeTags: e.typeTags ?? [e.type],
    issueNumber: e.issueNumber,
    issueKey: e.issueKey,
    localKey: e.localKey,
    source: e.source ?? "native",
    sourceRef: e.sourceRef,
    archived: Qn(e.archived),
    syncStatus: e.syncStatus ?? "local",
    content: e.content,
    system: {
      workspace: e.workspace,
      documentPath: e.module || void 0,
      lineNumber: e.lineNumber,
      createdAt: e.created ?? n ?? r,
      updatedAt: s,
      lastIndexed: n,
      authorIdentity: e.authorIdentity,
      lastModifiedBy: e.lastModifiedBy,
      createdByAgent: e.createdByAgent,
      linkedSessions: e.linkedSessions,
      linkedCommitSha: e.linkedCommitSha,
      linkedCommits: e.linkedCommits,
      documentId: e.documentId,
      origin: e.origin
    },
    fields: t
  };
  if (e.customFields)
    for (const o of Ft)
      o in e.customFields && a.system[o] === void 0 && (a.system[o] = o === "comments" ? xr(e.customFields[o]) : e.customFields[o]);
  return Cr(a);
}
function Er(e) {
  const t = e.fields, n = /* @__PURE__ */ new Set([
    "title",
    "status",
    "priority",
    "owner",
    "description",
    "tags",
    "dueDate",
    "progress",
    "assigneeEmail",
    "reporterEmail",
    "labels"
  ]), r = {};
  for (const [s, a] of Object.entries(t))
    n.has(s) || (r[s] = a);
  for (const s of ["linkedPullRequests", "linkedIssues", "activity", "comments", "triagedAt", "triagedBy"]) {
    const a = e.system[s];
    a !== void 0 && (r[s] = a);
  }
  return {
    id: e.id,
    type: e.primaryType,
    typeTags: e.typeTags,
    issueNumber: e.issueNumber,
    issueKey: e.issueKey,
    localKey: e.localKey,
    // Map fields to TrackerItem's fixed properties
    title: t.title ?? "",
    status: t.status ?? "to-do",
    priority: t.priority,
    owner: t.owner,
    description: t.description,
    tags: t.tags,
    dueDate: t.dueDate,
    progress: t.progress,
    assigneeEmail: t.assigneeEmail,
    reporterEmail: t.reporterEmail,
    labels: t.labels,
    module: e.system.documentPath ?? "",
    lineNumber: e.system.lineNumber,
    workspace: e.system.workspace,
    created: e.system.createdAt,
    updated: e.system.updatedAt,
    lastIndexed: e.system.lastIndexed ? new Date(e.system.lastIndexed) : /* @__PURE__ */ new Date(),
    content: e.content,
    archived: e.archived,
    archivedAt: void 0,
    // not stored on TrackerRecord -- derive from activity if needed
    origin: e.system.origin,
    source: e.source,
    sourceRef: e.sourceRef,
    authorIdentity: e.system.authorIdentity,
    lastModifiedBy: e.system.lastModifiedBy,
    createdByAgent: e.system.createdByAgent,
    linkedSessions: e.system.linkedSessions,
    linkedCommitSha: e.system.linkedCommitSha,
    linkedCommits: e.system.linkedCommits,
    documentId: e.system.documentId,
    syncStatus: e.syncStatus,
    customFields: Object.keys(r).length > 0 ? r : void 0
  };
}
const Ze = ({
  identity: e,
  showName: t = !1,
  size: n = 20
}) => {
  if (!e)
    return null;
  let r, s = null;
  typeof e == "string" ? (r = e, e.includes("@") && (s = e, r = e.split("@")[0])) : (s = e.email ?? null, r = e.displayName || s?.split("@")[0] || "Unknown");
  const a = un(r), o = dn(s || r);
  return /* @__PURE__ */ D("div", { className: "flex items-center gap-1.5 min-w-0", title: s ? `${r} (${s})` : r, children: [
    /* @__PURE__ */ g(
      "div",
      {
        className: "shrink-0 rounded-full flex items-center justify-center text-white font-medium",
        style: {
          width: n,
          height: n,
          fontSize: n * 0.45,
          backgroundColor: o
        },
        children: a
      }
    ),
    t && /* @__PURE__ */ g("span", { className: "text-xs text-[var(--nim-text-muted)] truncate", children: r })
  ] });
};
function Rr(e) {
  return e.map((t) => ({
    value: t.email,
    label: t.name || t.email,
    avatarIdentity: t.name || t.email
  }));
}
const Mr = ({ choices: e, value: t, allowNone: n, onPick: r, activeValue: s, testId: a }) => {
  const o = t == null || t === "", i = (d, l) => [
    "tracker-field-choice",
    d ? "tracker-field-choice-selected" : "",
    s === l ? "tracker-field-choice-active" : ""
  ].filter(Boolean).join(" "), u = (d) => d?.scrollIntoView?.({ block: "nearest" });
  return /* @__PURE__ */ D("div", { className: "tracker-field-choice-list", "data-testid": a, children: [
    n && /* @__PURE__ */ D(
      "button",
      {
        type: "button",
        role: "option",
        "aria-selected": o,
        className: i(o, ""),
        ref: s === "" ? u : void 0,
        onClick: () => r(""),
        children: [
          /* @__PURE__ */ g(ne, { icon: "remove", size: 15 }),
          /* @__PURE__ */ g("span", { className: "tracker-field-choice-label", children: "None" })
        ]
      }
    ),
    e.map((d) => {
      const l = d.value === t;
      return /* @__PURE__ */ D(
        "button",
        {
          type: "button",
          role: "option",
          "aria-selected": l,
          className: i(l, d.value),
          ref: s === d.value ? u : void 0,
          onClick: () => r(d.value),
          children: [
            d.avatarIdentity ? /* @__PURE__ */ g(Ze, { identity: d.avatarIdentity, size: 16 }) : /* @__PURE__ */ g(ne, { icon: d.icon ?? "circle", size: 15, style: d.color ? { color: d.color } : void 0 }),
            /* @__PURE__ */ g("span", { className: "tracker-field-choice-label", children: d.label }),
            l && /* @__PURE__ */ g(ne, { icon: "check", size: 15 })
          ]
        },
        d.value
      );
    })
  ] });
};
function _r(e, t) {
  const n = t.trim().toLowerCase();
  if (!n) return !0;
  const r = ge(e, "tags");
  return !!(e.issueKey?.toLowerCase().includes(n) || e.localKey?.toLowerCase().includes(n) || String(e.issueNumber ?? "").includes(n) || ce(e).toLowerCase().includes(n) || (e.system.documentPath ?? "").toLowerCase().includes(n) || String(ge(e, "assignee") ?? "").toLowerCase().includes(n) || Array.isArray(r) && r.some((s) => s.toLowerCase().includes(n)));
}
function Lr(e, { searchTerm: t = "", typeFilter: n = "all" }) {
  return e.filter((r) => !(!_r(r, t) || n !== "all" && r.primaryType !== n));
}
function yt(e) {
  return e == null || e === "";
}
function gt(e) {
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? void 0 : e.getTime();
  if (typeof e == "number") return e;
  if (typeof e == "string") {
    const t = new Date(e).getTime();
    return Number.isNaN(t) ? void 0 : t;
  }
}
function et(e, t, n) {
  const r = yt(e), s = yt(t);
  if (r && s) return 0;
  if (r) return 1;
  if (s) return -1;
  if (n === "date" || e instanceof Date || t instanceof Date) {
    const a = gt(e), o = gt(t);
    if (a !== void 0 && o !== void 0) return a - o;
  }
  return typeof e == "number" && typeof t == "number" ? e - t : typeof e == "boolean" && typeof t == "boolean" ? Number(e) - Number(t) : String(e).localeCompare(String(t));
}
function Or(e, t, n, r) {
  switch (n) {
    case "type":
      return e.primaryType.localeCompare(t.primaryType);
    case "module":
      return (e.system.documentPath ?? "").localeCompare(t.system.documentPath ?? "");
    case "lastIndexed": {
      const s = e.system.lastIndexed ? new Date(e.system.lastIndexed).getTime() : 0, a = t.system.lastIndexed ? new Date(t.system.lastIndexed).getTime() : 0;
      return s - a;
    }
    case "createdBy": {
      const s = (a) => {
        const o = a.system.authorIdentity;
        return o?.displayName || o?.email || o?.gitEmail || o?.gitName || "";
      };
      return s(e).localeCompare(s(t));
    }
    default: {
      const s = r?.find((i) => i.id === n), a = Ke(e, s ? re(e.primaryType, s) : n), o = Ke(t, s ? re(t.primaryType, s) : n);
      return et(a, o, s?.render);
    }
  }
}
function Bt(e) {
  return Dr(e);
}
function ya(e) {
  return Er(e);
}
const Kr = /* @__PURE__ */ new Set(["favorite", "viewed"]), Pt = /* @__PURE__ */ new Set([
  "favorites",
  "recently-viewed"
]), ht = {
  favorite: "your favorites",
  viewed: "what you recently opened"
};
function $t(e) {
  return Kr.has(e) ? e : null;
}
function Fr(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e.activeFilters ?? []) {
    if (!Pt.has(n)) continue;
    const r = n === "favorites" ? "favorite" : "viewed";
    t.has(r) || t.set(r, { source: "chip", field: r, label: ht[r] });
  }
  for (const n of e.columnFilters?.clauses ?? []) {
    const r = $t(n.field);
    r && !t.has(r) && t.set(r, { source: "clause", field: r, label: ht[r] });
  }
  return [...t.values()];
}
function Br(e) {
  const t = (e.activeFilters ?? []).filter(
    (o) => !Pt.has(o)
  ), n = (e.columnFilters?.clauses ?? []).filter(
    (o) => $t(o.field) === null
  ), r = t.length === (e.activeFilters ?? []).length, s = n.length === (e.columnFilters?.clauses ?? []).length;
  if (r && s) return e;
  const a = e.columnFilters ? { ...e.columnFilters, clauses: n } : null;
  return { ...e, activeFilters: t, columnFilters: a };
}
function ga(e) {
  if (e.length === 0) return "";
  const t = e.map((r) => r.label);
  return `This view also filters on ${t.length === 1 ? t[0] : `${t.slice(0, -1).join(", ")} and ${t[t.length - 1]}`}, which only exists in the desktop app. Those rows are not filtered out here.`;
}
const q = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
function kt(e, t) {
  let n = "";
  const r = t ? Math.max(e.length, t.length) : e.length;
  for (let s = 0; s <= r; s++) {
    const a = s < e.length ? q.indexOf(e[s]) : 0, o = t && s < t.length ? q.indexOf(t[s]) : 62;
    if (a === o) {
      n += q[a];
      continue;
    }
    const i = Math.floor((a + o) / 2);
    if (i > a)
      return n + q[i];
    n += q[a];
  }
  return n + q[31];
}
function Pr(e, t) {
  if (e === null && t === null)
    return "a0";
  if (e === null) {
    const n = q.indexOf(t[0]);
    return n > 1 ? q[Math.floor(n / 2)] : kt("", t);
  }
  if (t === null) {
    const n = e[e.length - 1], r = q.indexOf(n);
    return r < 61 ? e.slice(0, -1) + q[r + 1] : e + q[31];
  }
  return kt(e, t);
}
const $r = ["milestone", "goal"];
function Vr(e) {
  return $r.includes(e);
}
function Vt(e) {
  return e === "none" ? "status" : e;
}
function jr(e, t) {
  return t.find((r) => (be(r) || "").toLowerCase() === e)?.primaryType ?? "";
}
function Ur(e, t, n, r, s = "all") {
  const a = Vt(e);
  if (typeof a == "object") {
    const d = ke.get(t)?.fields.find((c) => c.name === a.fieldId);
    if (!d || d.multiValue || !["select", "boolean", "user", "relationship"].includes(d.type)) return [];
    const l = /* @__PURE__ */ new Map(), m = d.type === "boolean" ? [{ value: "true", label: "Yes" }, { value: "false", label: "No" }] : d.options ?? [];
    for (const c of m) {
      const p = typeof c == "string" ? c : c.value, y = typeof c == "string" ? c : c.label, I = `field:${a.fieldId}:value:${encodeURIComponent(p)}`;
      l.set(I, { key: I, value: p, label: y, empty: !1 });
    }
    for (const c of n) for (const p of Fe(c, a, r))
      l.has(p.key) || l.set(p.key, { ...p, fieldValue: c.fields[a.fieldId] });
    return [...l.values()].filter((c) => !c.empty).concat([...l.values()].filter((c) => c.empty));
  }
  if (a === "status") {
    const d = t === "all" ? "" : t;
    return fn(t, n).filter((l) => s !== "open" || !mn(d || jr(l.value, n), l.value)).map((l) => ({
      key: l.value,
      value: l.value,
      label: l.label,
      empty: !1
    }));
  }
  const o = /* @__PURE__ */ new Map();
  for (const d of n) {
    const l = Vr(a) ? new Map(Nt(d, a).map((m) => [m.itemId, m])) : null;
    for (const m of Fe(d, a, r))
      m.empty || o.has(m.key) || o.set(m.key, {
        key: m.key,
        value: m.value,
        label: m.label,
        empty: !1,
        ...m.value && l?.get(m.value) ? { ref: l.get(m.value) } : {}
      });
  }
  const i = [...o.values()].sort((d, l) => d.label.localeCompare(l.label, void 0, { sensitivity: "base" })), u = pn(a);
  return i.push({ key: u.key, value: null, label: u.label, empty: !0 }), i;
}
function zr(e, t, n, r) {
  const s = {};
  for (const a of t) s[a.key] = [];
  for (const a of e) {
    if (n === "status") {
      const o = (be(a) || "to-do").toLowerCase(), i = s[o] ? o : t[0]?.key ?? "to-do";
      (s[i] ??= []).push(a);
      continue;
    }
    for (const o of Fe(a, n))
      (s[o.key] ??= []).push(a);
  }
  for (const a of Object.keys(s))
    s[a] = tt(s[a], r);
  return s;
}
function tt(e, t) {
  if (e.length <= 1) return e;
  const n = [...e];
  return t === yn ? (n.sort((r, s) => {
    const a = De(r) ?? "", o = De(s) ?? "";
    return a < o ? -1 : a > o ? 1 : 0;
  }), n) : (n.sort((r, s) => et(
    it(r, t),
    it(s, t)
  )), n);
}
function Yr(e) {
  const { item: t, axis: n, sourceColumnKey: r, targetColumn: s, columnItems: a, dropIndex: o } = e, i = a.some((y) => y.id === t.id), d = (r === null ? i : r === s.key) ? {} : je(t, n, s);
  if (!d) return null;
  const l = a.filter((y) => y.id !== t.id);
  let m = o ?? l.length;
  if (i) {
    const y = a.findIndex((I) => I.id === t.id);
    y >= 0 && y < m && m--;
  }
  m = Math.max(0, Math.min(m, l.length));
  const c = m > 0 ? De(l[m - 1]) ?? null : null, p = m < l.length ? De(l[m]) ?? null : null;
  return { ...d, kanbanSortOrder: Pr(c, p) };
}
function je(e, t, n) {
  if (typeof t == "object") {
    const r = ke.get(e.primaryType)?.fields.find((s) => s.name === t.fieldId);
    if (!r || r.multiValue) return null;
    if (r.type === "boolean") return { [r.name]: n.value === null ? null : n.value === "true" };
    if (r.type === "select")
      return n.value !== null && !r.options?.some((s) => (typeof s == "string" ? s : s.value) === n.value) ? null : { [r.name]: n.value };
    if (r.type === "user") return n.empty ? { [r.name]: null } : n.fieldValue === void 0 ? null : { [r.name]: n.fieldValue };
    if (r.type === "relationship") {
      const s = Xe(n.fieldValue);
      return n.empty ? { [r.name]: Ne(r, []) } : s.length === 1 ? { [r.name]: Ne(r, s) } : null;
    }
    return null;
  }
  switch (t) {
    case "status":
      return n.value === null ? null : { [ot(e.primaryType, "workflowStatus")]: n.value };
    case "priority":
      return n.value === null ? null : { [ot(e.primaryType, "priority")]: n.value };
    case "milestone":
    case "goal":
      return Wr(e, t, n);
    default:
      return null;
  }
}
function Wr(e, t, n) {
  const r = gn(e.primaryType, t);
  if (!r) return null;
  const s = new Set(Nt(e, t).map((i) => i.itemId)), a = Xe(e.fields[r.name]).filter((i) => !s.has(i.itemId));
  if (n.value === null) return { [r.name]: Ne(r, a) };
  const o = hn(r, a, {
    ...n.ref ?? { title: n.label },
    itemId: n.value,
    trackerType: t
  });
  return { [r.name]: Ne(r, o) };
}
const Gr = {
  draft: {
    chip: "Draft, but committed?",
    headline: "Marked draft, but a linked session committed."
  },
  "ready-for-development": {
    chip: "Ready, but committed?",
    headline: "Marked ready for development, but a linked session committed."
  }
};
function Hr(e) {
  const t = e.system.derivedSignals?.find(
    (r) => r.kind === Be
  );
  if (t) return t;
  const [n] = Ot({
    primaryType: e.primaryType,
    status: be(e),
    linkedCommits: e.system.linkedCommits
  });
  return n?.kind === Be ? n : null;
}
function qr(e) {
  const t = Hr(e);
  if (!t) return null;
  const n = Gr[t.status];
  return n ? {
    chipLabel: n.chip,
    headline: n.headline,
    commitShas: [...t.commitShas],
    committedSessionIds: [...t.committedSessionIds]
  } : null;
}
function ha(e) {
  return e.slice(0, 8);
}
const ae = "__trackerItemId", Ee = "__trackerItemType", Xr = "__trackerActions";
function Jr(e, t) {
  return e.map((n) => {
    const r = {
      [ae]: n.id,
      [Ee]: n.primaryType
    };
    for (const s of t)
      r[s.id] = Ke(n, re(n.primaryType, s));
    return r;
  });
}
const jt = "builtin:ready", Qr = "readinessLeverage", Zr = /* @__PURE__ */ new Map([
  ["critical", 0],
  ["high", 1],
  ["medium", 2],
  ["low", 3]
]);
function bt(e) {
  return Zr.get(Je(e)) ?? 4;
}
function ka(e, t) {
  return [...e].sort((n, r) => {
    const s = t.get(n.id)?.unblocks ?? 0, a = t.get(r.id)?.unblocks ?? 0;
    if (s !== a) return a - s;
    const o = bt(n), i = bt(r);
    return o !== i ? o - i : ce(n).localeCompare(ce(r));
  });
}
function es() {
  return {
    id: jt,
    name: "Ready",
    builtIn: !0,
    definition: {
      ...bn(),
      viewMode: "list",
      statusScope: "open",
      sortBy: Qr,
      sortDirection: "desc",
      columnFilters: {
        combinator: "and",
        clauses: [{ field: kn, op: "=", value: "ready" }]
      }
    }
  };
}
function Ut(e) {
  return [
    es(),
    ...e.filter((t) => t.id !== jt)
  ];
}
const ts = ["startdate", "start", "startsat"], ns = ["targetdate", "duedate", "enddate", "end", "releasedat", "completedat"], rs = "created", ss = Date.UTC(1971, 0, 1);
function _e(e) {
  const t = wn(e);
  return t && t.getTime() > ss ? t : null;
}
function vt(e, t) {
  const n = new Map(Object.keys(e.fields).map((r) => [r.toLowerCase(), r]));
  for (const r of t) {
    const s = n.get(r);
    if (!s) continue;
    const a = _e(e.fields[s]);
    if (a) return { field: s, date: a };
  }
  return null;
}
function as(e) {
  const t = ke.get(e.primaryType);
  for (const n of t?.fields ?? []) {
    if (n.type !== "date" && n.type !== "datetime" || n.readOnly) continue;
    const r = _e(e.fields[n.name]);
    if (r) return { field: n.name, date: r };
  }
  return null;
}
function wt(e, t) {
  if (!t) return null;
  const n = _e(e.fields[t]);
  return n ? { field: t, date: n } : null;
}
function os(e, t) {
  const n = !!(t?.start || t?.end), r = n ? wt(e, t?.start) : vt(e, ts), s = n ? wt(e, t?.end) : vt(e, ns);
  if (r) {
    const i = s && s.date.getTime() > r.date.getTime();
    return {
      start: r.date,
      end: i ? s.date : null,
      startField: r.field,
      ...i ? { endField: s.field } : {}
    };
  }
  if (s) return { start: s.date, end: null, startField: s.field };
  if (n) return null;
  const a = as(e);
  if (a) return { start: a.date, end: null, startField: a.field };
  const o = _e(e.system.createdAt);
  return o ? { start: o, end: null, startField: rs } : null;
}
const is = 1440 * 60 * 1e3;
function zt(e) {
  return new Date(e.getFullYear(), e.getMonth(), e.getDate());
}
function ls(e) {
  const t = zt(e);
  return new Date(t.getFullYear(), t.getMonth(), t.getDate() - t.getDay());
}
function cs(e) {
  return new Date(e.getFullYear(), e.getMonth(), 1);
}
function Re(e, t) {
  switch (t) {
    case "day":
      return zt(e);
    case "week":
      return ls(e);
    case "month":
      return cs(e);
  }
}
function Yt(e, t) {
  const n = e.getFullYear(), r = e.getMonth(), s = e.getDate();
  switch (t) {
    case "day":
      return new Date(n, r, s + 1);
    case "week":
      return new Date(n, r, s + 7);
    case "month":
      return new Date(n, r + 1, 1);
  }
}
function us(e, t) {
  const n = Re(e, t), r = String(n.getMonth() + 1).padStart(2, "0"), s = String(n.getDate()).padStart(2, "0");
  return `${t}:${n.getFullYear()}-${r}-${s}`;
}
function ds(e) {
  return e <= 45 ? "day" : e <= 400 ? "week" : "month";
}
function fs(e, t, n) {
  const r = t === "month" ? { month: "short" } : { month: "short", day: "numeric" };
  return n && (r.year = "numeric"), e.toLocaleDateString(void 0, r);
}
function ms(e, t) {
  const n = [];
  let r = Re(e.start, t), s = null;
  for (; r.getTime() < e.end.getTime() && n.length < 400; ) {
    const a = Yt(r, t), o = s !== null && r.getFullYear() !== s;
    n.push({
      key: us(r, t),
      label: fs(r, t, o || n.length === 0),
      start: r,
      end: a
    }), s = r.getFullYear(), r = a;
  }
  return n;
}
function Ue(e, t) {
  const n = t.end.getTime() - t.start.getTime();
  if (n <= 0) return 0;
  const r = (e.getTime() - t.start.getTime()) / n;
  return Math.min(1, Math.max(0, r));
}
function ba(e, t) {
  if (!t) return null;
  const n = e.getTime();
  return n < t.start.getTime() || n > t.end.getTime() ? null : Ue(e, t);
}
function va(e, t, n, r, s) {
  const a = /* @__PURE__ */ new Map();
  for (const c of e)
    a.has(c.id) || a.set(c.id, os(c, s));
  const o = [...a.values()].filter((c) => c !== null), i = a.size - o.length;
  let u = null, d = "week", l = [];
  if (o.length > 0) {
    const c = Math.min(...o.map((v) => v.start.getTime())), p = Math.max(...o.map((v) => (v.end ?? v.start).getTime()));
    d = ds((p - c) / is);
    const y = Re(new Date(c), d), I = Yt(Re(new Date(p), d), d);
    u = { start: y, end: I }, l = ms(u, d);
  }
  const m = vn(e, t, r).map((c) => {
    const p = tt(c.items, n), y = [], I = [];
    for (const v of p) {
      const f = a.get(v.id) ?? null;
      if (!f || !u) {
        f || I.push(v);
        continue;
      }
      y.push({
        item: v,
        dates: f,
        startFraction: Ue(f.start, u),
        endFraction: Ue(f.end ?? f.start, u)
      });
    }
    return y.sort((v, f) => v.dates.start.getTime() - f.dates.start.getTime()), { key: c.key, label: c.label, bars: y, undated: I };
  });
  return {
    granularity: d,
    range: u,
    buckets: l,
    rows: m,
    datedCount: o.length,
    undatedCount: i
  };
}
function ze(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e) t.set(n.id, Bt(n));
  return { recordsById: t, records: [...t.values()] };
}
function Wt(e) {
  return Ut(
    e.map(Sn).filter((t) => t !== null)
  );
}
function St(e, t) {
  switch (t.type) {
    case "items-replaced":
      return { ...e, ...ze(t.items) };
    case "items-upserted": {
      const n = new Map(e.recordsById);
      for (const r of t.items) n.set(r.id, Bt(r));
      return { ...e, recordsById: n, records: [...n.values()] };
    }
    case "items-removed": {
      const n = new Map(e.recordsById);
      for (const r of t.itemIds) n.delete(r);
      return { ...e, recordsById: n, records: [...n.values()] };
    }
    case "saved-views-replaced":
      return { ...e, savedViews: Wt(t.savedViews) };
    case "presence":
      return { ...e, presence: t.members };
    case "status":
      return { ...e, sync: t.sync };
    case "mutation-rejected":
      return { ...e, rejection: t.rejection };
    default:
      return e;
  }
}
function ps(e) {
  let t = {
    ...ze([]),
    savedViews: Ut([]),
    presence: [],
    sync: e.status(),
    rejection: null,
    loaded: !1
  };
  const n = /* @__PURE__ */ new Set();
  let r = null, s = !1, a = !1, o = null;
  const i = (l) => {
    if (l !== t) {
      t = l;
      for (const m of n) m();
    }
  };
  return {
    getSnapshot: () => t,
    subscribe: (l) => (n.add(l), () => n.delete(l)),
    command: (l) => e.command(l),
    start: () => {
      a || (a = !0, r = e.subscribe((l) => {
        a && (o?.push(l), i(St(t, l)));
      }), !s && (s = !0, o = [], e.snapshot().then((l) => {
        if (!a) return;
        let m = {
          ...ze(l.items),
          savedViews: Wt(l.savedViews),
          presence: l.presence,
          sync: l.sync,
          // A fast rejection may arrive after subscribe but before the snapshot.
          rejection: t.rejection,
          loaded: !0
        };
        for (const c of o ?? []) m = St(m, c);
        o = null, i(m);
      })));
    },
    stop: () => {
      a = !1, r?.(), r = null;
    }
  };
}
const wa = {
  personalState: !0,
  renderableViewModes: /* @__PURE__ */ new Set(["list", "table", "kanban", "timeline", "radar", "tag-board", "inbox"])
}, Gt = {
  personalState: !1,
  renderableViewModes: /* @__PURE__ */ new Set(["list", "table", "kanban", "timeline", "radar", "tag-board"])
}, Ht = [], ue = Kn(null);
function Sa({
  dataSource: e,
  identity: t,
  capabilities: n = Gt,
  teamMembers: r = Ht,
  children: s
}) {
  const a = F(
    () => e ? ps(e) : null,
    [e]
  );
  ve(() => (a?.start(), () => a?.stop()), [a]);
  const o = F(
    () => ({ dataSource: e ?? null, dataStore: a, identity: t, capabilities: n, teamMembers: r }),
    [e, a, t, n, r]
  );
  return /* @__PURE__ */ g(Bn, { store: Pn, children: /* @__PURE__ */ g(ue.Provider, { value: o, children: s }) });
}
function Ta() {
  const e = we(ue);
  if (!e) throw new Error("Tracker surfaces must be rendered inside TrackersUIProvider");
  return e;
}
function ys() {
  return we(ue)?.capabilities ?? Gt;
}
function gs() {
  return we(ue)?.teamMembers ?? Ht;
}
function Ia() {
  const e = we(ue)?.dataSource;
  if (!e) throw new Error("Tracker surfaces must be rendered inside TrackersUIProvider");
  return e;
}
function qt() {
  const e = we(ue)?.dataStore;
  if (!e) throw new Error("Tracker surfaces must be rendered inside TrackersUIProvider");
  return e;
}
function hs(e, t = Object.is) {
  const n = qt(), r = X(e), s = X(t), a = X(null);
  r.current = e, s.current = t;
  const o = z(() => {
    const i = n.getSnapshot(), u = r.current, d = a.current;
    if (d?.store === n && d.selector === u && d.snapshot === i) return d.selection;
    const l = u(i);
    return d?.store === n && d.selector === u && s.current(d.selection, l) ? (a.current = { store: n, selector: u, snapshot: i, selection: d.selection }, d.selection) : (a.current = { store: n, selector: u, snapshot: i, selection: l }, l);
  }, [n]);
  return Mt(n.subscribe, o, o);
}
function Ca() {
  return hs((e) => e);
}
function xa() {
  return qt().command;
}
function Aa(e, t, n) {
  const r = ys(), {
    identity: s,
    capabilities: a = r,
    searchTerm: o = "",
    readinessByItemId: i,
    favoriteItemIds: u,
    viewedAtByItemId: d,
    nowMs: l
  } = n, { personalState: m } = a, c = F(
    () => m ? [] : Fr(t),
    [m, t]
  ), p = F(
    () => m ? t : Br(t),
    [m, t]
  ), y = F(() => tt(
    Lr(
      Tn(
        p.selectedType === "all" ? e : e.filter((v) => v.typeTags.includes(p.selectedType)),
        p,
        { identity: s, readinessByItemId: i, favoriteItemIds: u, viewedAtByItemId: d, nowMs: l }
      ),
      { searchTerm: o, typeFilter: "all" }
    ),
    p.ordering
  ), [e, p, s, o, i, u, d, l]);
  return { rows: F(() => {
    if (!p.sortColumns?.length) return y;
    const v = Dt(p.selectedType === "all" ? "" : p.selectedType);
    return [...y].sort((f, h) => {
      for (const S of p.sortColumns) {
        const A = Or(f, h, S.field, v);
        if (A) return S.direction === "asc" ? A : -A;
      }
      return f.id.localeCompare(h.id);
    });
  }, [y, p]), personalClauses: c };
}
const ks = "list";
function Na(e, t) {
  return t.renderableViewModes.has(e) ? { mode: e, substituted: !1 } : { mode: ks, substituted: !0 };
}
function he({
  icon: e,
  message: t,
  hint: n,
  children: r,
  testId: s
}) {
  return /* @__PURE__ */ g(
    "div",
    {
      className: "tracker-surface-message flex-1 flex items-center justify-center text-nim-muted",
      "data-testid": s,
      children: /* @__PURE__ */ D("div", { className: "text-center", children: [
        /* @__PURE__ */ g(ne, { icon: e, size: 48, className: "opacity-30" }),
        /* @__PURE__ */ g("p", { className: "mt-2 text-sm", children: t }),
        n ? /* @__PURE__ */ g("p", { className: "mt-1 text-xs text-nim-faint", children: n }) : null,
        r ? /* @__PURE__ */ g("div", { className: "mt-3 flex items-center justify-center gap-2", children: r }) : null
      ] })
    }
  );
}
function bs({
  item: e,
  identity: t,
  windowHours: n = 24,
  className: r = ""
}) {
  const s = F(() => Date.now(), [e]), a = F(
    () => Ir(e, t, s, n),
    [t, e, s, n]
  );
  return a ? /* @__PURE__ */ D(
    "span",
    {
      className: `inline-flex max-w-full items-center gap-1 rounded-full border border-[var(--nim-warning)]/35 bg-[var(--nim-warning)]/10 px-1.5 py-0.5 text-[10px] text-nim-muted ${r}`,
      title: a.summary,
      "data-testid": "tracker-recent-teammate-activity",
      children: [
        /* @__PURE__ */ g(ne, { icon: "group", size: 11, className: "shrink-0 text-[var(--nim-warning)]" }),
        /* @__PURE__ */ D("span", { className: "truncate", children: [
          a.actor.displayName,
          " · ",
          a.relativeLabel
        ] })
      ]
    }
  ) : null;
}
function le({
  label: e,
  color: t,
  variant: n = "primary",
  className: r = "",
  title: s
}) {
  return /* @__PURE__ */ g(
    "span",
    {
      className: `tracker-swatch-badge tracker-swatch-badge-${n} ${r}`,
      style: { "--tracker-swatch": t },
      title: s,
      children: /* @__PURE__ */ g("span", { className: "tracker-swatch-badge-label", children: e })
    }
  );
}
const Da = {
  "to-do": "#6b7280",
  "in-progress": "#eab308",
  "in-review": "#8b5cf6",
  done: "#22c55e",
  blocked: "#ef4444",
  "won't-fix": "#6b7280",
  "wont-fix": "#6b7280"
}, Ea = {
  backlog: "#6b7280",
  unstarted: "#6b7280",
  started: "#eab308",
  done: "#22c55e",
  cancelled: "#ef4444"
}, Ye = {
  critical: "#ef4444",
  high: "#f97316",
  medium: "#eab308",
  low: "#6b7280"
}, oe = "#6b7280";
function vs({ item: e, selected: t, showType: n, onOpen: r }) {
  const s = be(e), a = ge(e, "progress"), o = e.system.updatedAt ? new Date(e.system.updatedAt) : null;
  return /* @__PURE__ */ D("button", { type: "button", className: `tracker-stacked-row${t ? " is-selected" : ""}`, "data-testid": "tracker-list-row", "data-item-id": e.id, onClick: r, children: [
    /* @__PURE__ */ g("span", { className: "tracker-stacked-title", children: ce(e) }),
    /* @__PURE__ */ D("span", { className: "tracker-stacked-meta", children: [
      s ? /* @__PURE__ */ g(le, { label: s, color: Me(s, e.primaryType) }) : null,
      typeof a == "number" && Number.isFinite(a) ? /* @__PURE__ */ D("span", { children: [
        a,
        "%"
      ] }) : null,
      o && Number.isFinite(o.getTime()) ? /* @__PURE__ */ g("time", { dateTime: o.toISOString(), children: o.toLocaleDateString(void 0, { month: "short", day: "numeric" }) }) : null,
      n ? /* @__PURE__ */ g("span", { children: Et(e.primaryType) }) : null,
      e.issueKey ? /* @__PURE__ */ g("span", { className: "tracker-stacked-key", children: e.issueKey }) : null
    ] })
  ] });
}
const ws = (e) => ke.onChange(e);
function Ss({
  item: e,
  selected: t,
  unreadSlot: n,
  onOpen: r,
  onContextMenu: s
}) {
  const a = be(e), o = Je(e), i = ge(e, "assignee");
  return /* @__PURE__ */ D(
    "button",
    {
      type: "button",
      "data-testid": "tracker-list-row",
      "data-item-id": e.id,
      className: `tracker-list-row w-full flex items-center gap-2 px-3 py-1.5 text-left border-b border-nim transition-colors ${t ? "bg-nim-active" : "hover:bg-nim-tertiary"}`,
      onClick: r,
      onContextMenu: s,
      children: [
        /* @__PURE__ */ g(
          "span",
          {
            className: "w-2 h-2 rounded-full shrink-0",
            style: { backgroundColor: Ye[o || "medium"] || oe }
          }
        ),
        n,
        e.issueKey ? (
          // `text-nim-muted`, not `text-nim-faint`: the key is the item's
          // citable identifier, so it is content. Faint is the decorative tier
          // and measures 3.49:1 on the dark row background, under AA at any size.
          /* @__PURE__ */ g("span", { className: "shrink-0 font-mono text-[11px] uppercase tracking-[0.06em] text-nim-muted", children: e.issueKey })
        ) : null,
        /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate text-sm text-nim", children: ce(e) }),
        /* @__PURE__ */ g(
          le,
          {
            label: Et(e.primaryType),
            color: Qe(e.primaryType),
            className: "tracker-swatch-badge-column"
          }
        ),
        a ? /* @__PURE__ */ g(
          le,
          {
            label: a,
            color: Me(a, e.primaryType),
            className: "tracker-swatch-badge-column"
          }
        ) : null,
        /* @__PURE__ */ g("span", { className: "tracker-list-row-owner", children: i ? /* @__PURE__ */ g(Ze, { identity: i, size: 18 }) : null })
      ]
    }
  );
}
function Ra({
  rows: e,
  groupBy: t,
  selectedItemId: n = null,
  onOpenItem: r,
  loaded: s,
  renderUnreadSlot: a,
  onRowContextMenu: o,
  stacked: i = !1,
  showType: u = !0
}) {
  const d = z(() => JSON.stringify(
    [...new Set(e.map((c) => c.primaryType))].map((c) => {
      const p = ke.get(c);
      return [c, p?.displayName, p?.displayNamePlural];
    })
  ), [e]), l = Mt(ws, d, d), m = F(() => In(e, t), [e, t, l]);
  return s ? e.length === 0 ? /* @__PURE__ */ g(
    he,
    {
      icon: "checklist",
      message: "No items to display",
      hint: "Nothing in this tracker matches the current view.",
      testId: "tracker-list-empty"
    }
  ) : /* @__PURE__ */ g("div", { className: "tracker-list-view h-full overflow-y-auto", "data-testid": "tracker-list-view", children: m.map((c) => /* @__PURE__ */ D("div", { "data-testid": "tracker-list-group", "data-group-key": c.key, children: [
    t === "none" ? null : /* @__PURE__ */ D("div", { className: "sticky top-0 z-[1] flex items-center gap-2 bg-nim-secondary px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-nim-muted", children: [
      /* @__PURE__ */ g(ne, { icon: "chevron_right", size: 12 }),
      /* @__PURE__ */ g("span", { className: "flex-1 truncate", children: c.label }),
      /* @__PURE__ */ g("span", { children: c.items.length })
    ] }),
    c.items.map((p) => i ? /* @__PURE__ */ g(vs, { item: p, selected: n === p.id, showType: u, onOpen: (y) => r(p.id, ct(y)) }, p.id) : /* @__PURE__ */ g(
      Ss,
      {
        item: p,
        selected: n === p.id,
        unreadSlot: a?.(p.id),
        onOpen: (y) => r(p.id, ct(y)),
        onContextMenu: o ? (y) => o(p.id, y) : void 0
      },
      p.id
    ))
  ] }, c.key)) }) : /* @__PURE__ */ g(
    he,
    {
      icon: "checklist",
      message: "Loading tracker items...",
      testId: "tracker-list-loading"
    }
  );
}
const Ae = () => import("./TrackerCardStalenessPopover-rcXmGPwT.js"), Ts = Lt(
  () => Ae().then((e) => ({
    default: e.TrackerCardStalenessPopover
  }))
), Is = ({ item: e }) => {
  const [t, n] = U(!1), [r, s] = U(null), a = qr(e);
  return a ? /* @__PURE__ */ D(Fn, { children: [
    /* @__PURE__ */ D(
      "button",
      {
        ref: s,
        type: "button",
        draggable: !1,
        className: "tracker-card-staleness-chip tracker-card-chip tracker-card-chip-drift",
        "data-testid": "tracker-card-staleness-chip",
        "aria-expanded": t,
        "aria-haspopup": "dialog",
        "aria-label": a.headline,
        title: a.headline,
        onPointerEnter: () => {
          Ae();
        },
        onFocus: () => {
          Ae();
        },
        onPointerDown: () => {
          Ae();
        },
        onClick: (o) => {
          o.stopPropagation(), n((i) => !i);
        },
        onDoubleClick: (o) => o.stopPropagation(),
        children: [
          /* @__PURE__ */ g(ne, { icon: "help", size: 11 }),
          /* @__PURE__ */ g("span", { className: "tracker-card-chip-label", children: a.chipLabel })
        ]
      }
    ),
    t && r && /* @__PURE__ */ g(_t, { fallback: null, children: /* @__PURE__ */ g(
      Ts,
      {
        item: e,
        reference: r,
        onClose: () => n(!1)
      }
    ) })
  ] }) : null;
}, Cs = ({
  item: e,
  columnKey: t,
  cardIndex: n,
  selected: r,
  highlighted: s,
  dragging: a,
  onDragStart: o,
  onDragEnd: i,
  onSelect: u,
  onToggleSelected: d,
  onContextMenu: l,
  onOpenDocument: m,
  milestoneSlot: c,
  fieldsSlot: p,
  unreadSlot: y,
  favoriteSlot: I,
  currentIdentity: v
}) => {
  const f = Je(e), h = lt[e.primaryType] || oe, S = ge(e, "assignee"), A = [e.issueKey, Cn(e)].filter(Boolean).join(" · "), k = !!o;
  return /* @__PURE__ */ g(
    "div",
    {
      "data-testid": "tracker-kanban-card",
      "data-item-id": e.id,
      "data-card-index": n,
      role: "button",
      tabIndex: 0,
      draggable: k,
      onDragStart: o ? (b) => o(b, e, t) : void 0,
      onDragEnd: i,
      className: `tracker-kanban-card w-full text-left p-2.5 rounded-md bg-nim hover:bg-nim-tertiary border transition-colors mb-1.5 ${k ? "cursor-grab active:cursor-grabbing" : "cursor-pointer"} ${a ? "opacity-40" : ""} ${r || s ? "border-[var(--nim-primary)]" : "border-nim"}`,
      onClick: (b) => u(b, e),
      onDoubleClick: () => m?.(e.id),
      onKeyDown: (b) => {
        (b.key === "Enter" || b.key === " ") && (b.preventDefault(), u(b, e));
      },
      onContextMenu: l ? (b) => l(b, e) : void 0,
      children: /* @__PURE__ */ D("div", { className: "flex items-start gap-2", children: [
        /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            draggable: !1,
            className: `tracker-card-select-checkbox ${r ? "tracker-card-select-checkbox-checked" : "tracker-card-select-checkbox-unchecked"}`,
            "data-testid": "tracker-card-select-checkbox",
            role: "checkbox",
            "aria-checked": r,
            "aria-label": r ? "Deselect card" : "Select card",
            title: r ? "Deselect" : "Select for a bulk action",
            onClick: (b) => {
              b.stopPropagation(), d(e.id);
            },
            onDoubleClick: (b) => b.stopPropagation(),
            children: /* @__PURE__ */ g(ne, { icon: "check", size: 11 })
          }
        ),
        /* @__PURE__ */ g(
          "span",
          {
            className: "w-2 h-2 rounded-full mt-1.5 shrink-0",
            style: { backgroundColor: Ye[f || "medium"] || oe }
          }
        ),
        y,
        I,
        /* @__PURE__ */ D("div", { className: "flex-1 min-w-0", children: [
          A ? /* @__PURE__ */ g("div", { className: "text-[10px] font-mono font-medium uppercase tracking-[0.08em] text-nim-faint mb-0.5", children: A }) : null,
          /* @__PURE__ */ g("div", { className: "text-sm text-nim leading-snug line-clamp-2", children: ce(e) }),
          /* @__PURE__ */ D("div", { className: "flex items-center gap-1.5 mt-1.5 flex-wrap", children: [
            /* @__PURE__ */ g(le, { label: e.primaryType, color: h }),
            e.typeTags.filter((b) => b !== e.primaryType).map((b) => /* @__PURE__ */ g(
              le,
              {
                label: b,
                color: lt[b] || oe,
                variant: "secondary"
              },
              b
            )),
            f && f !== "medium" ? /* @__PURE__ */ g(
              le,
              {
                label: f,
                color: Ye[f] || oe
              }
            ) : null,
            /* @__PURE__ */ g(Is, { item: e }),
            /* @__PURE__ */ g(bs, { item: e, identity: v }),
            c,
            p,
            S ? /* @__PURE__ */ g("span", { className: "ml-auto", children: /* @__PURE__ */ g(Ze, { identity: S, size: 18 }) }) : null
          ] })
        ] })
      ] })
    }
  );
};
function Tt({ onCreate: e }) {
  const [t, n] = U(() => crypto.randomUUID()), [r, s] = U(!1), [a, o] = U(""), [i, u] = U(!1), [d, l] = U(null);
  return r ? /* @__PURE__ */ D("form", { className: "flex flex-wrap gap-2 p-2", onSubmit: (m) => {
    m.preventDefault(), !(i || !a.trim()) && (u(!0), l(null), e(a.trim(), t).then(() => {
      o(""), n(crypto.randomUUID());
    }, (c) => l(c instanceof Error ? c.message : "The item could not be created")).finally(() => u(!1)));
  }, children: [
    /* @__PURE__ */ g("input", { "aria-label": "New item title", autoFocus: !0, className: "min-w-0 flex-1 rounded border border-nim bg-nim px-2 py-1 text-xs", value: a, disabled: i, onChange: (m) => o(m.target.value) }),
    /* @__PURE__ */ g("button", { type: "submit", className: "text-xs text-nim-link", disabled: i || !a.trim(), children: i ? "Creating…" : "Create" }),
    /* @__PURE__ */ g("button", { type: "button", className: "text-xs", disabled: i, onClick: () => s(!1), children: "Cancel" }),
    d ? /* @__PURE__ */ g("div", { className: "w-full text-xs text-nim-error", role: "alert", children: d }) : null
  ] }) : /* @__PURE__ */ g("button", { type: "button", className: "px-3 py-2 text-left text-xs text-nim-link", onClick: () => s(!0), children: "+ New" });
}
function xs(e, t) {
  const n = (r, s) => {
    const a = Number(r.dataset.cardIndex);
    return Number.isInteger(a) ? a : s;
  };
  for (let r = 0; r < e.length; r++) {
    const s = e[r].getBoundingClientRect();
    if (t < s.top + s.height / 2) return n(e[r], r);
  }
  return e.length ? n(e[e.length - 1], e.length - 1) + 1 : 0;
}
let We = null, Ge = null, He = null, It = !1;
function As() {
  It || (It = !0, document.addEventListener("dragover", (e) => {
    const t = e.target?.closest?.(".tracker-kanban-column");
    if (!t) return;
    e.preventDefault(), e.dataTransfer && (e.dataTransfer.dropEffect = "move");
    const n = t.dataset.columnKey;
    if (!n) return;
    const r = t.querySelector(".kanban-cards-container");
    if (!r) return;
    const s = Array.from(r.querySelectorAll(".tracker-kanban-card"));
    Ge?.(n, xs(s, e.clientY));
  }), document.addEventListener("drop", (e) => {
    if (!e.target?.closest?.(".tracker-kanban-board")) return;
    e.preventDefault();
    const t = e.target?.closest?.(".tracker-kanban-column");
    We?.(t?.dataset.columnKey ?? "", -1);
  }), document.addEventListener("dragleave", (e) => {
    const t = e.target?.closest?.(".tracker-kanban-column");
    t && !t.contains(e.relatedTarget) && He?.();
  }));
}
function Ns(e) {
  return As(), We = e.onDrop, Ge = e.onDragOver, He = e.onDragLeave, () => {
    We = null, Ge = null, He = null;
  };
}
const Ds = /* @__PURE__ */ new Set();
function Ma({
  rows: e,
  trackerType: t,
  groupBy: n,
  ordering: r,
  statusScope: s = "all",
  resolveRelationshipLabel: a,
  selectedItemIds: o = Ds,
  highlightedItemId: i = null,
  onToggleSelected: u,
  onOpenItem: d,
  onItemUpdate: l,
  currentIdentity: m,
  sortDirection: c = "asc",
  onCreateItem: p,
  hiddenColumns: y,
  preserveRowOrder: I,
  renderCardFields: v
}) {
  const [f, h] = U(null), [S, A] = U(null), [k, b] = U(null), [C, E] = U(null), L = X(null), V = X(null), P = X(null), N = X(null), Y = Vt(n), G = F(
    () => Ur(n, t, e, a, s),
    [n, t, e, a, s]
  ), Z = F(
    () => {
      const T = zr(e, G, Y, r);
      if (I) {
        const _ = new Map(e.map((j, M) => [j.id, M]));
        for (const j of Object.values(T)) j.sort((M, $) => _.get(M.id) - _.get($.id));
        return T;
      }
      return r !== "manual" && c === "desc" ? Object.fromEntries(Object.entries(T).map(([_, j]) => [_, [...j].reverse()])) : T;
    },
    [e, G, Y, r, c, I]
  ), J = z(() => {
    h(null), A(null), b(null), L.current = null, V.current = null, P.current = null, N.current = null;
  }, []), de = z((T, _, j) => {
    E(null), h(_.id), L.current = _, V.current = j, T.dataTransfer.effectAllowed = "move", T.dataTransfer.setData("text/plain", _.id);
  }, []);
  return ve(() => {
    if (l)
      return Ns({
        onDragOver: (T, _) => {
          P.current = T, N.current = _, A(T), b(_);
        },
        onDrop: () => {
          const T = L.current, _ = V.current, j = P.current, M = G.find((H) => H.key === j), $ = N.current;
          if (J(), !T || !M) return;
          const ee = r !== "manual" ? _ === M.key ? null : je(T, Y, M) : Yr({
            item: T,
            axis: Y,
            sourceColumnKey: _,
            targetColumn: M,
            columnItems: Z[M.key] ?? [],
            dropIndex: $
          });
          ee && Promise.resolve(l(T, ee)).catch((H) => {
            E(H instanceof Error ? H.message : String(H));
          });
        },
        onDragLeave: () => {
          P.current = null, N.current = null, A(null), b(null);
        }
      });
  }, [Y, J, G, Z, l, r]), e.length === 0 && G.length === 0 ? /* @__PURE__ */ D("div", { className: "tracker-kanban-empty flex flex-col", children: [
    /* @__PURE__ */ g(
      he,
      {
        icon: "view_kanban",
        message: "No items to display",
        testId: "tracker-kanban-empty"
      }
    ),
    p ? /* @__PURE__ */ g(Tt, { onCreate: (T, _) => p(T, void 0, _) }) : null
  ] }) : /* @__PURE__ */ D(
    "div",
    {
      className: "tracker-kanban-board h-full flex flex-col overflow-hidden relative",
      "data-testid": "tracker-kanban-board",
      children: [
        C ? /* @__PURE__ */ g("div", { className: "tracker-kanban-mutation-error px-3 py-2 text-xs text-nim-error", role: "alert", children: C }) : null,
        /* @__PURE__ */ g("div", { className: "flex-1 flex gap-3 p-3 overflow-x-auto overflow-y-hidden min-h-0", children: G.filter((T) => !y?.includes(T.value ?? T.key)).map((T) => {
          const _ = Z[T.key] ?? [], j = Y === "status" && T.value ? Me(T.value, t) : oe;
          return /* @__PURE__ */ D(
            "div",
            {
              "data-testid": `tracker-kanban-column-${T.key}`,
              "data-column-key": T.key,
              className: `tracker-kanban-column flex flex-col min-w-[260px] max-w-[320px] flex-1 min-h-0 rounded-lg bg-nim-secondary ${T.empty ? "tracker-kanban-column-empty-bucket border border-dashed border-nim" : ""} ${S === T.key ? "ring-1 ring-[var(--nim-primary)]" : ""}`,
              children: [
                /* @__PURE__ */ D("div", { className: "flex items-center gap-2 px-3 py-2 border-b border-nim", children: [
                  /* @__PURE__ */ g(
                    "span",
                    {
                      className: `w-2 h-2 rounded-full shrink-0 ${T.empty ? "border border-nim" : ""}`,
                      style: T.empty ? void 0 : { backgroundColor: j }
                    }
                  ),
                  /* @__PURE__ */ g("span", { className: "flex-1 truncate text-xs font-medium text-nim", children: T.label }),
                  /* @__PURE__ */ g("span", { className: "text-[10px] font-semibold text-nim-faint", children: _.length })
                ] }),
                /* @__PURE__ */ D("div", { className: "kanban-cards-container flex-1 overflow-y-auto px-1.5 pt-1.5 min-h-0", children: [
                  _.map((M, $) => /* @__PURE__ */ D(On.Fragment, { children: [
                    S === T.key && k === $ && f !== M.id ? /* @__PURE__ */ g("div", { className: "h-[2px] bg-[var(--nim-primary)] rounded-full mx-1 my-0.5" }) : null,
                    /* @__PURE__ */ g(
                      Cs,
                      {
                        item: M,
                        columnKey: T.key,
                        cardIndex: $,
                        selected: o.has(M.id),
                        highlighted: i === M.id,
                        dragging: f === M.id,
                        onDragStart: l ? de : void 0,
                        onDragEnd: J,
                        onSelect: () => d(M.id),
                        onToggleSelected: (ee) => u?.(ee),
                        onOpenDocument: d,
                        currentIdentity: m,
                        fieldsSlot: v?.(M)
                      }
                    ),
                    $ === _.length - 1 && S === T.key && k === _.length ? /* @__PURE__ */ g("div", { className: "h-[2px] bg-[var(--nim-primary)] rounded-full mx-1 my-0.5" }) : null
                  ] }, `${T.key}:${M.id}`)),
                  p ? /* @__PURE__ */ g(Tt, { onCreate: (M, $) => {
                    const H = je({ primaryType: t, fields: {} }, Y, T);
                    return H ? p(M, H, $) : Promise.reject(new Error("Items cannot be created in this derived group"));
                  } }) : null,
                  /* @__PURE__ */ g("div", { className: "min-h-[40px]" })
                ] })
              ]
            },
            T.key
          );
        }) })
      ]
    }
  );
}
function Es(e, t) {
  const n = t.trim().toLowerCase();
  if (!n) return [...e];
  const r = (s) => {
    const a = s.label.toLowerCase();
    return a.split(/[\s@._+-]+/).some((o) => o.startsWith(n)) ? 0 : a.includes(n) ? 1 : s.value.toLowerCase().includes(n) ? 2 : -1;
  };
  return e.map((s, a) => ({ choice: s, index: a, rank: r(s) })).filter((s) => s.rank >= 0).sort((s, a) => s.rank - a.rank || s.index - a.index).map((s) => s.choice);
}
function Rs({ anchor: e, choices: t, value: n, initialQuery: r = "", onPick: s, onCancel: a }) {
  const [o, i] = U(r), u = X(!1), d = z((k) => {
    !k || u.current || (u.current = !0, k.focus({ preventScroll: !0 }));
  }, []), l = F(() => Es(t, o), [t, o]), m = !o.trim(), c = F(() => [...m ? [""] : [], ...l.map((k) => k.value)], [m, l]), [p, y] = U(void 0), I = p !== void 0 && c.includes(p) ? p : !o.trim() && c.includes(n) ? n : c[m && c.length > 1 ? 1 : 0], v = jn({
    open: !0,
    onOpenChange: (k) => {
      k || a();
    },
    elements: { reference: e },
    placement: "bottom-start",
    whileElementsMounted: Un,
    middleware: [
      zn(4),
      Yn({ padding: 8 }),
      Wn({ padding: 8 }),
      Gn({
        padding: 8,
        apply({ availableHeight: k, elements: b }) {
          b.floating.style.maxHeight = `${Math.max(0, k)}px`;
        }
      })
    ]
  }), f = Hn(v.context), h = qn(v.context, { role: "listbox" }), { getFloatingProps: S } = Xn([f, h]), A = (k) => {
    if (k.stopPropagation(), k.key === "Escape") {
      k.preventDefault(), a();
      return;
    }
    if (k.key === "Enter") {
      k.preventDefault(), I !== void 0 && s(I);
      return;
    }
    if (k.key !== "ArrowDown" && k.key !== "ArrowUp") return;
    k.preventDefault();
    const b = I === void 0 ? -1 : c.indexOf(I), C = k.key === "ArrowDown" ? Math.min(c.length - 1, b + 1) : Math.max(0, b - 1);
    y(c[C]);
  };
  return /* @__PURE__ */ g(Jn, { children: /* @__PURE__ */ D(
    "div",
    {
      ref: v.refs.setFloating,
      style: v.floatingStyles,
      ...S({ onKeyDown: A }),
      className: "tracker-field-popover tracker-grid-choice-popover",
      "data-testid": "tracker-grid-choice-popover",
      children: [
        /* @__PURE__ */ g(
          "input",
          {
            ref: d,
            type: "text",
            className: "tracker-grid-choice-filter",
            placeholder: "Filter...",
            "aria-label": "Filter choices",
            value: o,
            onChange: (k) => {
              i(k.target.value), y(void 0);
            }
          }
        ),
        c.length === 0 ? /* @__PURE__ */ g("div", { className: "tracker-grid-choice-empty", children: "No matches" }) : /* @__PURE__ */ g(Mr, { choices: l, value: n, allowNone: m, activeValue: I, onPick: s })
      ]
    }
  ) });
}
function Ms(e) {
  const t = document.activeElement instanceof HTMLElement ? document.activeElement : null, n = document.createElement("div");
  n.className = "tracker-grid-choice-root", document.body.appendChild(n);
  const r = Vn(n);
  return r.render(/* @__PURE__ */ g(Rs, { ...e })), () => {
    const s = document.activeElement, a = !s || s === document.body || !!s.closest(".tracker-grid-choice-popover");
    queueMicrotask(() => {
      r.unmount(), n.remove(), a && t?.isConnected && t.focus({ preventScroll: !0 });
    });
  };
}
function Se(e, t, n, r) {
  const s = e.key;
  if (s === "Escape") {
    e.preventDefault(), e.stopPropagation(), r(!1);
    return;
  }
  if (s === "Enter") {
    e.preventDefault(), n(t(), !1);
    return;
  }
  s === "Tab" && n(t(), !0);
}
function _s(e) {
  if (!e) return !0;
  const n = e.model?.[e.prop];
  return String(e.val ?? "") === String(n ?? "");
}
function Ls(e, t) {
  if (!e) return;
  if (e.focus(), _s(t)) {
    e.select();
    return;
  }
  const n = e.value.length;
  try {
    e.setSelectionRange(n, n);
  } catch {
  }
}
function Xt(e) {
  const t = e.kind === "number" ? "number" : e.kind === "url" ? "url" : "text";
  return (n, r, s) => {
    let a = null;
    const o = {
      editCell: void 0,
      getValue: () => a?.value ?? "",
      async componentDidRender() {
        await new Promise((i) => setTimeout(i, 0)), Ls(a, o.editCell);
      },
      render(i) {
        return i("input", {
          type: t,
          class: "tracker-grid-editor-input",
          min: e.min,
          max: e.max,
          value: o.editCell?.val ?? "",
          ref: (u) => {
            a = u;
          },
          onKeyDown: (u) => Se(u, () => a?.value ?? "", r, s)
        });
      }
    };
    return o;
  };
}
function Jt(e) {
  return (t, n, r) => {
    let s = null;
    const a = () => {
      const i = o.editCell, u = i && "value" in i ? i.value : i?.val;
      return String(u ?? "");
    }, o = {
      editCell: void 0,
      // RevoGrid may autosave on close; a cell nothing was picked in keeps its value.
      getValue: a,
      componentDidRender() {
        if (s || !o.element) return;
        const i = a(), u = String(o.editCell?.val ?? "");
        s = Ms({
          anchor: o.element,
          // A stored value that is no longer a choice stays one, so opening the cell does not lose it.
          choices: i && !e.some((d) => d.value === i) ? [{ value: i, label: i }, ...e] : e,
          value: i,
          initialQuery: u !== i ? u : "",
          onPick: (d) => n(d, !1),
          onCancel: () => r(!1)
        });
      },
      disconnectedCallback() {
        s?.(), s = null;
      },
      render(i) {
        const u = a();
        return i(
          "div",
          { class: "tracker-grid-choice-anchor" },
          e.find((d) => d.value === u)?.label ?? u
        );
      }
    };
    return o;
  };
}
function Os(e, t) {
  return (n, r, s) => {
    const a = t.teamMembers?.() ?? [];
    return (a.length === 0 ? Xt(e) : Jt(Rr(a)))(n, r, s);
  };
}
function Ks(e) {
  return (t, n, r) => {
    let s = null;
    const a = e.options ?? [], o = `tracker-grid-tags-${String(t.prop)}`, i = {
      editCell: void 0,
      getValue: () => s?.value ?? "",
      async componentDidRender() {
        await new Promise((u) => setTimeout(u, 0)), s?.focus(), s?.select();
      },
      render(u) {
        const d = i.editCell?.val, l = Array.isArray(d) ? d.join(", ") : String(d ?? "");
        return [
          u("input", {
            type: "text",
            class: "tracker-grid-editor-input",
            list: a.length > 0 ? o : void 0,
            value: l,
            ref: (m) => {
              s = m;
            },
            onKeyDown: (m) => Se(m, () => s?.value ?? "", n, r)
          }),
          ...a.length > 0 ? [u(
            "datalist",
            { id: o },
            a.map((m) => u("option", { value: m.value }, m.label))
          )] : []
        ];
      }
    };
    return i;
  };
}
function Fs(e) {
  const t = e.kind === "datetime" ? "datetime-local" : "date";
  return (n, r, s) => {
    let a = null;
    const o = {
      editCell: void 0,
      getValue: () => a?.value ?? "",
      async componentDidRender() {
        await new Promise((i) => setTimeout(i, 0)), a?.focus();
      },
      render(i) {
        const u = o.editCell?.val, d = u == null || u === "" ? "" : t === "date" ? String(u).slice(0, 10) : String(u).slice(0, 16);
        return i("input", {
          type: t,
          class: "tracker-grid-editor-input",
          value: d,
          ref: (l) => {
            a = l;
          },
          onKeyDown: (l) => Se(l, () => a?.value ?? "", r, s)
        });
      }
    };
    return o;
  };
}
function Bs() {
  return (e, t, n) => {
    let r = null;
    const s = {
      editCell: void 0,
      getValue: () => r?.checked ?? !1,
      async componentDidRender() {
        await new Promise((a) => setTimeout(a, 0)), r?.focus();
      },
      render(a) {
        const o = s.editCell?.val;
        return a("input", {
          type: "checkbox",
          class: "tracker-grid-editor-checkbox",
          checked: o === !0 || o === "true",
          ref: (u) => {
            r = u;
          },
          onChange: () => t(r?.checked ?? !1, !1),
          onKeyDown: (u) => Se(u, () => r?.checked ?? !1, t, n)
        });
      }
    };
    return s;
  };
}
function Ps(e, t) {
  return (n, r, s) => {
    let a = null;
    const o = `tracker-grid-rel-${String(n.prop)}`, i = () => {
      const m = t.relationshipCandidates?.() ?? [], c = e.targetTrackerTypes;
      return !c || c === "*" ? m : m.filter((p) => c.includes(p.trackerType));
    }, u = (m) => m.issueKey ? `${m.issueKey} -- ${m.title}` : m.title, d = () => {
      const m = a?.value ?? "";
      if (!m.trim()) return [];
      const c = new Map(i().map((y) => [u(y), y.itemId])), p = new Map(
        i().filter((y) => y.issueKey).map((y) => [y.issueKey, y.itemId])
      );
      return m.split(",").map((y) => y.trim()).filter(Boolean).map((y) => c.get(y) ?? p.get(y)).filter((y) => !!y);
    }, l = {
      editCell: void 0,
      getValue: d,
      async componentDidRender() {
        await new Promise((m) => setTimeout(m, 0)), a?.focus(), a?.select();
      },
      render(m) {
        const c = l.editCell?.val, p = Array.isArray(c) ? c : c ? [c] : [], y = new Map(i().map((v) => [v.itemId, v])), I = p.map((v) => {
          const f = typeof v == "string" ? v : v?.itemId, h = f ? y.get(f) : void 0;
          return h ? u(h) : v?.issueKey ?? v?.title ?? "";
        }).filter(Boolean).join(", ");
        return [
          m("input", {
            type: "text",
            class: "tracker-grid-editor-input",
            list: o,
            placeholder: e.multiValue ? "Comma-separated items" : "Pick an item",
            value: I,
            ref: (v) => {
              a = v;
            },
            onKeyDown: (v) => Se(v, d, r, s)
          }),
          m(
            "datalist",
            { id: o },
            i().slice(0, 200).map((v) => m("option", { value: u(v) }, u(v)))
          )
        ];
      }
    };
    return l;
  };
}
function Qt(e, t = {}) {
  switch (e.kind) {
    case "readonly":
      return;
    case "select":
      return Jt((e.options ?? []).map((n) => ({
        value: n.value,
        label: n.label,
        icon: n.icon,
        color: n.color
      })));
    case "multiselect":
      return Ks(e);
    case "date":
    case "datetime":
      return Fs(e);
    case "boolean":
      return Bs();
    case "relationship":
      return Ps(e, t);
    case "user":
      return Os(e, t);
    default:
      return Xt(e);
  }
}
function $s(e, t = {}) {
  return (n, r, s) => {
    let a;
    const o = {
      editCell: void 0,
      getValue: () => a?.getValue?.(),
      async componentDidRender() {
        await a?.componentDidRender?.();
      },
      render(i) {
        const u = e(o.editCell), d = Qt(u, t);
        if (!d)
          return a = void 0, i("span", {}, "");
        const l = d(n, r, s);
        return l.editCell = o.editCell, a = l, l.render(i);
      }
    };
    return o;
  };
}
function pe(e, t, n) {
  return e("span", { class: "tracker-grid-cell-text", ...n ? { title: n } : {} }, t);
}
function Ct(e, t, n) {
  return e(
    "span",
    { class: "tracker-grid-cell-badge", style: { "--tracker-swatch": n } },
    t
  );
}
function qe(e, t, n) {
  if (t == null || t === "") return null;
  switch (e.render) {
    case "tags":
      return (Array.isArray(t) ? t : [t]).map(String).filter(Boolean);
    case "relationship":
      return Xe(t).map((r) => Nn(r, n)).filter(Boolean);
    default:
      return null;
  }
}
function Vs(e, t, n, r) {
  if (t == null || t === "") return "";
  switch (e.render) {
    case "date":
      return Rt(t).display;
    case "tags":
      return (qe(e, t, r) ?? []).join(", ");
    case "url": {
      if (typeof t == "object" && t !== null && "url" in t) {
        const s = t;
        return s.label ?? s.url;
      }
      return String(t);
    }
    case "relationship":
      return (qe(e, t, r) ?? []).join(", ");
    case "avatar": {
      if (typeof t == "object" && t !== null) {
        const s = t;
        return String(
          s.displayName ?? s.email ?? s.gitEmail ?? s.gitName ?? ""
        );
      }
      return String(t);
    }
    case "badge":
      return ie(n, re(n, e))?.options?.find((o) => o.value === String(t))?.label ?? String(t);
    case "progress":
      return typeof t == "number" ? `${t}%` : String(t);
    default:
      return typeof t == "boolean" ? t ? "Yes" : "No" : String(t);
  }
}
function js(e, t, n) {
  return e(
    "span",
    {
      class: "tracker-grid-cell-type-icon",
      style: { color: Qe(t) },
      title: n
    },
    e("span", { class: "material-symbols-outlined" }, An(t))
  );
}
function Us(e, t, n, r) {
  return e(
    "span",
    {
      class: n ? "tracker-grid-cell-favorite is-favorite" : "tracker-grid-cell-favorite",
      title: n ? "Remove from favorites" : "Add to favorites",
      // The grid focuses a cell on pointerdown, which would open the detail
      // panel behind the star. Swallow both events so the star is a pure toggle.
      onPointerDown: (s) => {
        s.preventDefault(), s.stopPropagation();
      },
      onClick: (s) => {
        s.preventDefault(), s.stopPropagation(), r(t);
      }
    },
    e(
      "span",
      { class: "material-symbols-outlined tracker-grid-cell-favorite-icon" },
      n ? "star" : "star_outline"
    )
  );
}
function Zt(e, t) {
  return e(
    "button",
    {
      type: "button",
      class: `tracker-grid-cell-menu tracker-grid-cell-menu-${t}`,
      title: "Item actions",
      "aria-label": "Item actions",
      // Preserve RevoGrid's current range so opening the menu can apply to the
      // whole selection when this row is already inside it.
      onPointerDown: (n) => {
        n.preventDefault(), n.stopPropagation();
      },
      onClick: (n) => {
        n.preventDefault(), n.stopPropagation(), n.currentTarget.dispatchEvent(new MouseEvent("contextmenu", {
          bubbles: !0,
          cancelable: !0,
          composed: !0,
          clientX: n.clientX,
          clientY: n.clientY,
          button: 2
        }));
      }
    },
    e(
      "span",
      { class: "material-symbols-outlined tracker-grid-cell-menu-icon" },
      "more_horiz"
    )
  );
}
function zs(e, t, n, r) {
  const s = (o) => {
    o.preventDefault(), o.stopPropagation();
  }, a = (o) => {
    s(o), r.onOpenDetail(n);
  };
  return t ? e("span", { class: "tracker-grid-cell-key" }, [
    e(
      "button",
      {
        type: "button",
        class: "tracker-grid-cell-key-link",
        title: "Open details",
        onClick: a
      },
      t
    ),
    ...r.onOpenDocument ? [e(
      "span",
      {
        class: "tracker-grid-cell-key-open",
        title: "Open as a document",
        "aria-label": "Open as a document",
        // The grid focuses a cell on pointerdown; keep this a pure action so
        // the icon does not also move the selection out from under the click.
        onPointerDown: s,
        onClick: (o) => {
          s(o), r.onOpenDocument?.(n);
        }
      },
      e(
        "span",
        { class: "material-symbols-outlined tracker-grid-cell-key-open-icon" },
        "open_in_full"
      )
    )] : []
  ]) : e("span", { class: "tracker-grid-cell-key" }, [
    e(
      "button",
      {
        type: "button",
        class: "tracker-grid-cell-key-link is-icon-only",
        title: "Open details",
        "aria-label": "Open details",
        onClick: a
      },
      e(
        "span",
        { class: "material-symbols-outlined tracker-grid-cell-key-open-icon" },
        "open_in_full"
      )
    )
  ]);
}
function Ys(e, t, n, r) {
  const s = (a) => {
    a.preventDefault(), a.stopPropagation();
  };
  return e(
    "button",
    {
      type: "button",
      class: "tracker-grid-cell-title-link",
      title: t || "Untitled",
      // The grid focuses a cell on pointerdown; keep the click a pure open.
      onPointerDown: s,
      onClick: (a) => {
        s(a), r.onOpenDetail(n);
      }
    },
    t || "Untitled"
  );
}
function Ws(e, t, { favorites: n, rowActions: r = !1, resolveLabel: s, keyLink: a } = {}) {
  return (o, i) => {
    const u = i.model?.[e.id], d = t || String(i.model?.[Ee] ?? ""), l = Vs(e, u, d, s), m = a?.titleOpens === !0;
    if ((n || r || m) && (e.role === "title" || e.id === "title")) {
      const c = String(i.model?.[ae] ?? "");
      return o("span", { class: "tracker-grid-cell-title" }, [
        ...n ? [Us(
          o,
          c,
          n.favoriteItemIds.has(c),
          n.onToggleFavorite
        )] : [],
        m && a ? Ys(o, l, c, a) : pe(o, l),
        ...r ? [Zt(o, "title")] : []
      ]);
    }
    if (a && e.id === "key")
      return zs(
        o,
        l,
        String(i.model?.[ae] ?? ""),
        a
      );
    if (!l) return pe(o, "");
    if (e.render === "type-icon")
      return js(o, String(u), l);
    if (e.render === "badge") {
      const c = e.role === "workflowStatus" ? Me(String(u), d) : e.role === "priority" ? xn(String(u)) : Qe(String(u));
      return Ct(o, l, c);
    }
    if (e.render === "tags" || e.render === "relationship") {
      const c = qe(e, u, s) ?? [];
      return o(
        "span",
        { class: "tracker-grid-cell-tags" },
        c.map((p) => Ct(o, p, "#6b7280"))
      );
    }
    return e.render === "date" ? pe(o, l, Rt(u).title) : pe(o, l);
  };
}
function Gs() {
  return {
    prop: Xr,
    name: "",
    size: 36,
    minSize: 36,
    maxSize: 36,
    pin: "colPinEnd",
    sortable: !1,
    readonly: !0,
    cellTemplate: (e) => Zt(e, "column")
  };
}
function xt(e) {
  return {
    prop: e.id,
    name: e.label,
    size: e.width ?? 200,
    minSize: 60,
    sortable: !1,
    readonly: !0,
    cellTemplate: (t, n) => {
      const r = String(n.model?.[e.id] ?? "");
      return pe(t, r, r);
    }
  };
}
function Hs(e, t, n) {
  return (r) => r(
    "span",
    { class: "tracker-grid-header" },
    [
      r("span", { class: "tracker-grid-header-label" }, e.label),
      r("span", { class: "tracker-grid-header-actions" }, [
        ...n ? [r(
          "span",
          {
            class: t ? "tracker-grid-header-filter is-filtered" : "tracker-grid-header-filter",
            title: t ? "Column filtered" : `Filter ${e.label}`,
            onClick: (s) => {
              s.preventDefault(), s.stopPropagation();
              const o = s.currentTarget?.getBoundingClientRect() ?? DOMRect.fromRect({ x: s.clientX, y: s.clientY, width: 0, height: 0 });
              n(e.id, o);
            }
          },
          r(
            "span",
            { class: "material-symbols-outlined tracker-grid-header-filter-icon" },
            "filter_alt"
          )
        )] : []
      ])
    ]
  );
}
function qs(e, {
  trackerType: t,
  columnWidths: n = {},
  isRowEditable: r,
  editorContext: s = {},
  filteredColumnIds: a,
  onOpenFilter: o,
  sortingEnabled: i = !1,
  favorites: u,
  rowActions: d = !1,
  keyLink: l,
  resolveRelationshipLabel: m
}) {
  return e.map((c) => {
    const p = ie(t, c.id), y = Oe(p), I = c.editable ? t ? Qt(y, s) : $s((v) => {
      const f = String(v?.model?.[Ee] ?? ""), h = ie(f, re(f, c));
      return Oe(h);
    }, s) : void 0;
    return {
      prop: c.id,
      name: c.label,
      size: n[c.id] ?? (typeof c.width == "number" ? c.width : 280),
      minSize: c.minWidth ?? 60,
      sortable: i && c.sortable,
      // RevoGrid re-sorts `source` on every assignment using the sorting config,
      // so its comparer -- not the pre-sort in TrackerGridView -- decides the
      // final row order. Its default stringifies everything; delegate to the
      // shared comparator so both surfaces agree and dates stay chronological.
      cellCompare: (v, f, h) => et(f?.[v], h?.[v], c.render),
      editor: I,
      readonly: ({ model: v }) => {
        if (!I) return !0;
        const f = v?.[ae];
        if (!t) {
          const h = String(v?.[Ee] ?? ""), S = ie(h, re(h, c));
          if (Oe(S).kind === "readonly") return !0;
        }
        return typeof f == "string" ? !r(f) : !0;
      },
      cellTemplate: Ws(c, t, {
        favorites: u,
        rowActions: d,
        resolveLabel: m,
        keyLink: l
      }),
      ...o ? {
        columnTemplate: Hs(
          c,
          a?.has(c.id) ?? !1,
          o
        )
      } : {}
    };
  });
}
function Xs(e, t) {
  if (!t) return !0;
  const n = typeof t.composedPath == "function" ? t.composedPath() : [];
  if (n.length > 0) return n.includes(e);
  const r = t.target;
  return r instanceof Node ? e.contains(r) : !0;
}
function Js(e) {
  ve(() => {
    const t = e.current;
    if (!t) return;
    const n = (r) => {
      const s = r.detail;
      Xs(t, s?.original) || r.preventDefault();
    };
    return t.addEventListener("beforekeydown", n), () => t.removeEventListener("beforekeydown", n);
  }, [e]);
}
const Qs = () => import("./TrackerColumnFilterPopover-HFbJ65rk.js"), Zs = Lt(
  () => Qs().then((e) => ({
    default: e.TrackerColumnFilterPopover
  }))
);
function ea(e) {
  return /* @__PURE__ */ g(_t, { fallback: null, children: /* @__PURE__ */ g(Zs, { ...e }) });
}
function ta(e, t, n) {
  const { sortBy: r, sortDirection: s = "desc", sortColumns: a, onSortChange: o, onWidthsChange: i } = t;
  return ve(() => {
    if (!o && !i) return;
    const u = (m) => {
      if (!o) return;
      const p = m.detail?.column?.prop;
      !p || !n.some((y) => y.id === p) || (m.preventDefault(), o(p, r === p && s === "desc" ? "asc" : "desc"));
    }, d = (m) => {
      const c = m.detail, p = {};
      for (const y of Object.values(c ?? {}))
        y?.prop && n.some((I) => I.id === y.prop) && Number.isFinite(y.size) && (p[y.prop] = Math.max(40, Math.min(2e3, y.size)));
      Object.keys(p).length && i?.(p);
    }, l = e.current;
    return l?.addEventListener("beforesorting", u, !0), l?.addEventListener("aftercolumnresize", d, !0), () => {
      l?.removeEventListener("beforesorting", u, !0), l?.removeEventListener("aftercolumnresize", d, !0);
    };
  }, [e, r, s, o, i, n]), F(() => {
    const u = (a?.length ? a : r ? [{ field: r, direction: s }] : []).filter((d) => n.some((l) => l.id === d.field)).map((d) => ({ prop: d.field, order: d.direction }));
    return u.length ? { columns: u } : void 0;
  }, [r, s, a, n]);
}
function na(e, t) {
  const n = [...e], r = [];
  for (const s of t) {
    const a = s.after ? n.findIndex((o) => o.prop === s.after) : -1;
    a >= 0 ? n.splice(a + 1, 0, xt(s)) : r.push(xt(s));
  }
  return [...n, ...r];
}
const ra = () => !1, At = "__trackerRowClass", sa = "tracker-grid-row-selected";
function _a({
  rows: e,
  trackerType: t,
  columnConfig: n,
  sortBy: r,
  sortDirection: s = "desc",
  sortColumns: a,
  onSortChange: o,
  onWidthsChange: i,
  columnFilters: u,
  onColumnFiltersChange: d,
  resolveRelationshipLabel: l,
  isRowEditable: m = ra,
  onItemsUpdate: c,
  selectedItemId: p,
  onOpenItem: y,
  titleOpensItem: I,
  onRowContextMenu: v,
  loaded: f,
  derivedColumns: h
}) {
  const [S, A] = U(null), [k, b] = U(null), C = X(null), E = X(null), L = t === "all" ? "" : t, V = F(
    () => Dt(L),
    [L]
  ), P = F(
    () => n ?? Dn(L),
    [n, L]
  ), N = F(
    () => P.visibleColumns.map((w) => V.find((x) => x.id === w)).filter((w) => w !== void 0),
    [P.visibleColumns, V]
  ), Y = F(
    () => new Set((u?.clauses ?? []).map((w) => w.field)),
    [u]
  ), G = gs(), Z = X(G);
  Z.current = G;
  const J = F(() => ({ teamMembers: () => Z.current }), []), de = F(
    () => [
      ...na(qs(N, {
        trackerType: L,
        sortingEnabled: !!o,
        columnWidths: P.columnWidths,
        isRowEditable: m,
        editorContext: J,
        filteredColumnIds: Y,
        onOpenFilter: d ? (w, x) => A({ columnId: w, rect: x }) : void 0,
        // The favorite star is a personal-lane affordance; a host that has one
        // renders it through its own grid. Not reconstructed here.
        rowActions: !1,
        keyLink: y ? { onOpenDetail: y, titleOpens: I } : void 0,
        resolveRelationshipLabel: l
      }), h ?? []),
      ...v ? [Gs()] : []
    ],
    [
      N,
      o,
      L,
      P.columnWidths,
      m,
      J,
      Y,
      d,
      y,
      I,
      l,
      h,
      v
    ]
  ), T = F(() => {
    const w = Jr(e, N);
    return h?.length ? w.map((x, O) => {
      const K = { ...x };
      for (const W of h) K[W.id] = W.value(e[O]);
      return K;
    }) : w;
  }, [e, N, h]), _ = F(
    () => p ? T.map(
      (w) => w[ae] === p ? { ...w, [At]: sa } : w
    ) : T,
    [T, p]
  ), j = ta(C, { sortBy: r, sortDirection: s, sortColumns: a, onSortChange: o, onWidthsChange: i }, N), M = F(
    () => new Map(e.map((w) => [w.id, w])),
    [e]
  ), $ = z(
    async (w) => {
      try {
        const K = (await E.current?.getVisibleSource?.("rgRow"))?.[w]?.[ae];
        if (typeof K == "string") return M.get(K) ?? null;
      } catch {
      }
      const x = T[w]?.[ae];
      return typeof x == "string" ? M.get(x) ?? null : null;
    },
    [T, M]
  ), ee = z(
    async (w, x) => {
      const O = await $(w);
      if (!O || !m(O.id)) return null;
      const K = {};
      for (const [W, R] of Object.entries(x)) {
        const B = N.find(
          (te) => te.id === W
        );
        if (!B?.editable) continue;
        const fe = re(O.primaryType, B), Te = ie(O.primaryType, fe);
        if (!Te || Te.readOnly) continue;
        const me = En(Te, R);
        JSON.stringify(O.fields[fe] ?? null) !== JSON.stringify(me ?? null) && (K[fe] = me);
      }
      return Object.keys(K).length > 0 ? { itemId: O.id, updates: K } : null;
    },
    [m, $, N]
  ), H = z(
    async (w) => {
      if (!c) return;
      const x = w.detail, O = "data" in x && x.data != null ? Object.entries(x.data).map(([R, B]) => ({
        rowIndex: Number(R),
        changes: B
      })) : [
        {
          rowIndex: x.rowIndex,
          changes: {
            [String(x.prop)]: x.val
          }
        }
      ], W = (await Promise.all(
        O.map(
          ({ rowIndex: R, changes: B }) => ee(R, B)
        )
      )).filter(
        (R) => R !== null
      );
      if (W.length !== 0) {
        b(null);
        try {
          await c(W);
        } catch (R) {
          b(
            R instanceof Error ? R.message : String(R)
          );
        }
      }
    },
    [ee, c]
  ), nt = z(
    async (w) => {
      const x = w.detail?.rowIndex;
      if (!y || typeof x != "number" || !p) return;
      const O = await $(x);
      O && y(O.id);
    },
    [y, $, p]
  ), rt = z(async () => {
    const w = (await E.current?.getFocused?.())?.cell?.y;
    if (typeof w != "number") return;
    const x = await $(w);
    x && y && y(x.id);
  }, [y, $]), st = z(async () => {
    const w = E.current, x = await w?.getFocused?.(), O = x?.column?.prop;
    !w || !x || O == null || await w.setCellEdit?.(x.cell.y, O, x.rowType);
  }, []), en = z(
    async (w) => {
      if (!v) return;
      const O = w.target?.closest?.(
        "[data-rgrow]"
      )?.getAttribute("data-rgrow");
      if (O == null) return;
      const K = Number(O);
      if (!Number.isFinite(K)) return;
      w.preventDefault();
      const W = { x: w.clientX, y: w.clientY }, R = await E.current?.getSelectedRange?.().catch(() => null), fe = R && typeof R.y == "number" && typeof R.y1 == "number" && K >= Math.min(R.y, R.y1) && K <= Math.max(R.y, R.y1) && R ? Array.from(
        { length: Math.abs(R.y1 - R.y) + 1 },
        (te, nn) => Math.min(R.y, R.y1) + nn
      ) : [K], me = (await Promise.all(
        fe.map((te) => $(te))
      )).filter((te) => te !== null).map((te) => te.id);
      me.length !== 0 && v({ itemIds: me, point: W });
    },
    [v, $]
  );
  Js(C);
  const tn = z(
    (w) => {
      if (!y) return;
      const x = w.key;
      w.nativeEvent.composedPath().some(
        (K) => K instanceof HTMLElement && (K.classList.contains("tracker-grid-editor-input") || K.classList.contains("tracker-grid-choice-anchor") || K.classList.contains("tracker-grid-editor-checkbox"))
      ) || (x === "Enter" || x === "F2") && (w.preventDefault(), w.stopPropagation(), x === "Enter" ? rt() : st());
    },
    [st, y, rt]
  );
  if (ve(() => {
    if (!c && !y) return;
    let w = null;
    const x = () => {
      const B = C.current?.querySelector(
        "revo-grid"
      );
      return !B || B === w ? !!B : (O(w), w = B, E.current = B, c && B.addEventListener("afteredit", K), y && B.addEventListener("afterfocus", W), !0);
    }, O = (B) => {
      B?.removeEventListener("afteredit", K), B?.removeEventListener("afterfocus", W);
    }, K = (B) => {
      H(B);
    }, W = (B) => {
      nt(B);
    }, R = typeof MutationObserver > "u" ? null : new MutationObserver(() => {
      x() && R?.disconnect();
    });
    return !x() && C.current && R?.observe(C.current, {
      childList: !0,
      subtree: !0
    }), () => {
      R?.disconnect(), O(w), E.current === w && (E.current = null);
    };
  }, [H, nt, c, y]), !f)
    return /* @__PURE__ */ g(
      he,
      {
        icon: "table",
        message: "Loading tracker items...",
        testId: "tracker-grid-loading"
      }
    );
  const at = Rn(u), Le = S ? N.find((w) => w.id === S.columnId) : void 0;
  return /* @__PURE__ */ D(
    "div",
    {
      className: "tracker-grid-view relative flex h-full w-full min-h-0 flex-col bg-nim",
      "data-testid": "tracker-grid-view",
      children: [
        k ? /* @__PURE__ */ g(
          "div",
          {
            className: "tracker-grid-mutation-error px-3 py-2 text-xs text-nim-error",
            role: "alert",
            children: k
          }
        ) : null,
        /* @__PURE__ */ D(
          "div",
          {
            ref: C,
            className: "tracker-grid-canvas relative min-h-0 flex-1 outline-none",
            tabIndex: y ? 0 : void 0,
            onKeyDownCapture: tn,
            onContextMenu: (w) => {
              en(w);
            },
            children: [
              e.length === 0 && !at ? /* @__PURE__ */ g(
                he,
                {
                  icon: "table",
                  message: "No tracker items yet.",
                  testId: "tracker-grid-empty"
                }
              ) : /* @__PURE__ */ g(
                $n,
                {
                  columns: de,
                  source: _,
                  rowClass: At,
                  sorting: j,
                  theme: "compact",
                  hideAttribution: !0,
                  resize: !0,
                  range: !0,
                  readonly: !c
                },
                `${L}:${r ?? ""}:${s}:${JSON.stringify(a)}`
              ),
              e.length === 0 && at ? /* @__PURE__ */ D(
                "div",
                {
                  className: "absolute inset-x-0 top-10 flex flex-col items-center gap-2 pt-6 text-sm text-nim-muted",
                  "data-testid": "tracker-grid-filtered-empty",
                  children: [
                    /* @__PURE__ */ g("span", { children: "No items match these column filters." }),
                    /* @__PURE__ */ g(
                      "button",
                      {
                        className: "text-xs underline hover:text-nim",
                        onClick: () => d?.({ combinator: "and", clauses: [] }),
                        children: "Clear column filters"
                      }
                    )
                  ]
                }
              ) : null
            ]
          }
        ),
        S && d ? /* @__PURE__ */ g(
          ea,
          {
            anchorRect: S.rect,
            columnId: S.columnId,
            columnLabel: Le?.label ?? S.columnId,
            field: Le ? ie(
              L,
              re(L, Le)
            ) : void 0,
            clauses: _n(u, S.columnId),
            combinator: u?.combinator ?? "and",
            onApply: (w, x) => {
              d({
                ...Mn(
                  u,
                  S.columnId,
                  w
                ),
                combinator: x
              });
            },
            onClose: () => A(null)
          }
        ) : null
      ]
    }
  );
}
function La(e, t) {
  return ar(Ln, e, t);
}
export {
  Qt as $,
  jt as A,
  Gt as B,
  Xr as C,
  wa as D,
  ae as E,
  Ee as F,
  Da as G,
  Cs as H,
  Is as I,
  Sa as J,
  ks as K,
  ea as L,
  Gs as M,
  oe as N,
  qs as O,
  Ye as P,
  Jr as Q,
  Qr as R,
  Ea as S,
  he as T,
  Ze as U,
  Tt as V,
  ms as W,
  Ur as X,
  Se as Y,
  es as Z,
  $s as _,
  le as a,
  Fr as a0,
  zr as a1,
  Xs as a2,
  ka as a3,
  Ns as a4,
  Vt as a5,
  je as a6,
  Yr as a7,
  xs as a8,
  os as a9,
  Ue as aa,
  ds as ab,
  tt as ac,
  zt as ad,
  cs as ae,
  ls as af,
  us as ag,
  Re as ah,
  Js as ai,
  xa as aj,
  Ca as ak,
  Ia as al,
  qt as am,
  Ut as an,
  Br as ao,
  va as b,
  ba as c,
  rs as d,
  hs as e,
  Vs as f,
  La as g,
  Aa as h,
  Na as i,
  Ra as j,
  Ma as k,
  _a as l,
  Mr as m,
  ya as n,
  ga as o,
  se as p,
  Tr as q,
  qr as r,
  ha as s,
  Rr as t,
  Ta as u,
  pa as v,
  ys as w,
  bs as x,
  Pt as y,
  Kr as z
};
//# sourceMappingURL=trackerReadiness-7BkIYlPX.js.map
